import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.experts');
import { OnInit, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-experts',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.experts/view.scss */
@charset "UTF-8";
.ops-page {
  --ops-ink: #25221f;
  --ops-muted: #77736c;
  --ops-line: #ddd9d1;
  --ops-line-soft: #ece9e3;
  --ops-soft: #f6f7f3;
  --ops-olive: #30491f;
  --ops-green: #52732e;
  --ops-orange: #b8521b;
  --ops-canvas: #f4f5f1;
  min-height: 100%;
  color: var(--ops-ink);
  background: var(--ops-canvas);
}

.ops-page *,
.ops-page *::before,
.ops-page *::after,
.ops-modal-backdrop *,
.ops-modal-backdrop *::before,
.ops-modal-backdrop *::after {
  box-sizing: border-box;
}

.ops-page button,
.ops-page input,
.ops-page select,
.ops-page textarea,
.ops-modal-backdrop button,
.ops-modal-backdrop input,
.ops-modal-backdrop select,
.ops-modal-backdrop textarea {
  font: inherit;
}

.ops-shell {
  width: min(100%, 1500px);
  margin: 0 auto;
  padding-right: 32px;
  padding-left: 32px;
}

.ops-header {
  position: relative;
  z-index: 2;
  border-bottom: 1px solid #d8d5ce;
  background: #fff;
  box-shadow: 0 1px 0 rgba(42, 40, 35, 0.025);
}

.ops-header__inner {
  height: 112px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 26px;
}

.ops-heading {
  min-width: 0;
  animation: ops-fade-up 500ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #817d75;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.12em;
}

.ops-eyebrow i,
.ops-result-meta > div i {
  width: 3px;
  height: 3px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #c5c0b8;
}

.ops-eyebrow strong {
  color: var(--ops-orange);
  font-weight: 900;
}

.ops-heading h1 {
  margin: 7px 0 0;
  color: #1f1d1a;
  font-size: 24px;
  font-weight: 900;
  line-height: 1.1;
  letter-spacing: -0.035em;
}

.ops-heading > p {
  margin: 7px 0 0;
  color: #706c65;
  font-size: 13px;
  line-height: 1.45;
}

.ops-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
  animation: ops-fade-up 500ms 70ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-header-status {
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 13px;
  border: 1px solid #d9d7d0;
  border-radius: 10px;
  background: #fafaf8;
  color: #5f6f50;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.ops-header-status i {
  position: relative;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #587b34;
}

.ops-header-status i::after {
  position: absolute;
  inset: -4px;
  border: 1px solid rgba(88, 123, 52, 0.26);
  border-radius: inherit;
  content: "";
  animation: ops-live 2.4s ease-out infinite;
}

.ops-primary-button {
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 17px;
  border: 0;
  border-radius: 10px;
  background: var(--ops-olive);
  color: #fff;
  box-shadow: 0 8px 20px rgba(48, 73, 31, 0.17);
  cursor: pointer;
  font-size: 13px;
  font-weight: 850;
  transition: transform 180ms ease, background 180ms ease, box-shadow 180ms ease;
}

.ops-primary-button svg {
  width: 16px;
  height: 16px;
  transition: transform 260ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-primary-button:hover {
  background: #3d592a;
  box-shadow: 0 11px 24px rgba(48, 73, 31, 0.22);
  transform: translateY(-1px);
}

.ops-primary-button:hover svg {
  transform: rotate(90deg);
}

.ops-primary-button:active {
  transform: translateY(0) scale(0.98);
}

.ops-content {
  display: grid;
  gap: 22px;
  padding-top: 24px;
  padding-bottom: 32px;
}

.ops-summary,
.ops-panel {
  overflow: hidden;
  border: 1px solid #d9d6cf;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 13px 32px rgba(42, 40, 35, 0.06), 0 2px 5px rgba(42, 40, 35, 0.03);
}

.ops-summary {
  min-height: 82px;
  display: grid;
  grid-template-columns: 245px minmax(0, 1fr);
  background: linear-gradient(105deg, #fff 0%, #fbfbf8 100%);
  animation: ops-panel-in 540ms 100ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-summary__intro {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px;
  border-right: 1px solid var(--ops-line-soft);
}

.ops-summary__icon {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 11px;
  background: #edf2e8;
  color: #47672d;
}

.ops-summary__icon svg {
  width: 20px;
  height: 20px;
}

.ops-summary__intro strong {
  display: block;
  color: #34312d;
  font-size: 13px;
  font-weight: 900;
}

.ops-summary__intro p {
  margin: 5px 0 0;
  color: #8b877f;
  font-size: 10px;
  white-space: nowrap;
}

.ops-summary__grid {
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.ops-stat {
  --stat-color: #8a9ab0;
  position: relative;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 7px;
  padding: 0 20px;
  border-right: 1px solid var(--ops-line-soft);
  animation: ops-stat-in 460ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-stat:nth-child(1) {
  animation-delay: 170ms;
}

.ops-stat:nth-child(2) {
  animation-delay: 220ms;
}

.ops-stat:nth-child(3) {
  animation-delay: 270ms;
}

.ops-stat:nth-child(4) {
  animation-delay: 320ms;
}

.ops-stat:last-child {
  border-right: 0;
}

.ops-stat::before {
  position: absolute;
  top: 20px;
  right: 18px;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: var(--stat-color);
  content: "";
}

.ops-stat > span {
  color: #77736c;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
}

.ops-stat > div {
  display: flex;
  align-items: baseline;
  gap: 5px;
}

.ops-stat strong {
  color: #292622;
  font-size: 25px;
  font-weight: 900;
  line-height: 0.9;
  letter-spacing: -0.04em;
}

.ops-stat small {
  color: #aaa69f;
  font-size: 10px;
}

.ops-stat--neutral {
  --stat-color: #8a9ab0;
}

.ops-stat--green {
  --stat-color: #52732e;
}

.ops-stat--violet {
  --stat-color: #70578e;
}

.ops-stat--amber {
  --stat-color: #c77813;
}

.ops-panel {
  animation: ops-panel-in 540ms 170ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-toolbar {
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--ops-line-soft);
}

.ops-tabs {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 3px;
  border-radius: 10px;
  background: #eff1ed;
}

.ops-tab {
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #716e67;
  cursor: pointer;
  font-size: 11px;
  font-weight: 800;
  white-space: nowrap;
  transition: color 170ms ease, background 170ms ease, box-shadow 170ms ease, transform 170ms ease;
}

.ops-tab em {
  min-width: 19px;
  height: 19px;
  display: inline-grid;
  place-items: center;
  padding: 0 5px;
  border-radius: 999px;
  background: rgba(87, 83, 75, 0.08);
  color: #8a867f;
  font-size: 9px;
  font-style: normal;
  font-weight: 900;
}

.ops-tab:hover {
  color: #34312d;
}

.ops-tab.is-active {
  background: #fff;
  color: #2f4024;
  box-shadow: 0 2px 8px rgba(45, 51, 40, 0.1), inset 0 0 0 1px rgba(62, 82, 45, 0.08);
  transform: translateY(-1px);
}

.ops-tab.is-active em {
  background: #e7eee0;
  color: #47632f;
}

.ops-filter-group {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ops-search,
.ops-select {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  border: 1px solid #d6d3cc;
  border-radius: 9px;
  background: #fff;
  color: #858078;
  transition: border-color 170ms ease, box-shadow 170ms ease;
}

.ops-search {
  width: 265px;
  padding-left: 12px;
}

.ops-select {
  width: 145px;
  padding-left: 11px;
}

.ops-search:focus-within,
.ops-select:focus-within {
  border-color: #879d71;
  box-shadow: 0 0 0 3px rgba(83, 116, 47, 0.11);
}

.ops-search > svg,
.ops-select > svg {
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

.ops-search input,
.ops-select select {
  width: 100%;
  height: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #403d38;
  font-size: 12px;
}

.ops-search input {
  padding: 0 34px 0 10px;
}

.ops-select select {
  padding: 0 9px;
}

.ops-search input::placeholder {
  color: #a39f97;
}

.ops-search > button {
  position: absolute;
  right: 7px;
  width: 23px;
  height: 23px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: #f0f1ed;
  color: #77736c;
  cursor: pointer;
  font-size: 14px;
}

.ops-check {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: #625f59;
  cursor: pointer;
  font-size: 12px;
  white-space: nowrap;
}

.ops-check input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.ops-check > span {
  width: 34px;
  height: 20px;
  display: flex;
  align-items: center;
  padding: 3px;
  border-radius: 999px;
  background: #d8d9d4;
  transition: background 180ms ease;
}

.ops-check > span i {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(25, 27, 23, 0.18);
  transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-check input:checked + span {
  background: #547535;
}

.ops-check input:checked + span i {
  transform: translateX(14px);
}

.ops-check strong {
  font-weight: 750;
}

.ops-result-meta {
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 18px;
  border-bottom: 1px solid var(--ops-line-soft);
  background: #fcfcfa;
}

.ops-result-meta > div {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #7f7b74;
  font-size: 11px;
}

.ops-result-meta > div strong {
  color: var(--ops-orange);
  font-size: 14px;
  font-weight: 900;
}

.ops-reset-button {
  padding: 6px 8px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #6e6a63;
  cursor: pointer;
  font-size: 11px;
  font-weight: 800;
  transition: color 160ms ease, background 160ms ease;
}

.ops-reset-button:hover {
  background: #eef0ea;
  color: #40572f;
}

.ops-table-wrap {
  width: 100%;
  overflow: hidden;
}

.ops-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  text-align: left;
}

.ops-table thead {
  background: #f5f6f2;
}

.ops-table th {
  height: 40px;
  padding: 0 12px;
  border-bottom: 1px solid #ddd9d2;
  color: #6f6b64;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.025em;
  white-space: nowrap;
}

.ops-table th:first-child,
.ops-table td:first-child {
  padding-left: 18px;
}

.ops-table th:last-child,
.ops-table td:last-child {
  padding-right: 18px;
}

.ops-table th.is-number,
.ops-table td.is-number {
  text-align: right;
}

.ops-table td {
  height: 66px;
  padding: 0 12px;
  border-bottom: 1px solid #ece9e3;
  color: #4f4b45;
  font-size: 13px;
  vertical-align: middle;
}

.ops-table tbody:last-child tr:last-child td,
.ops-table tbody > tr:last-child td {
  border-bottom: 0;
}

.ops-row {
  animation: ops-row-in 450ms cubic-bezier(0.22, 1, 0.36, 1) both;
  transition: background 170ms ease, box-shadow 170ms ease;
}

.ops-row:hover {
  background: #fafbf8;
  box-shadow: inset 3px 0 0 #688649;
}

.ops-identity {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 11px;
}

.ops-identity > div {
  min-width: 0;
}

.ops-identity > div > strong {
  display: block;
  overflow: hidden;
  color: #302d29;
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-identity > div > p {
  margin: 5px 0 0;
  overflow: hidden;
  color: #8f8b84;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-mark,
.ops-avatar {
  width: 38px;
  height: 38px;
  display: inline-grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 900;
  transition: transform 180ms ease, box-shadow 180ms ease;
}

.ops-mark--survey {
  border: 1px solid #d7e4cd;
  background: #eef4e9;
  color: #527136;
}

.ops-mark--harness {
  border: 1px solid #ded7e7;
  background: #f2eff6;
  color: #67547e;
}

.ops-avatar {
  border-radius: 12px;
  background: linear-gradient(145deg, #3d552a, #2d411f);
  color: #fff;
  box-shadow: 0 5px 12px rgba(48, 73, 31, 0.16);
  font-size: 12px;
}

.ops-row:hover .ops-mark,
.ops-row:hover .ops-avatar {
  box-shadow: 0 6px 13px rgba(49, 57, 43, 0.11);
  transform: translateY(-1px);
}

.ops-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 9px;
  border: 1px solid var(--status-line);
  border-radius: 999px;
  background: var(--status-bg);
  color: var(--status-color);
  font-size: 11px;
  font-weight: 850;
  white-space: nowrap;
}

.ops-status i {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: currentColor;
}

.status-live {
  --status-bg: #eef5e8;
  --status-color: #4c6e2f;
  --status-line: #d2e1c5;
}

.status-draft {
  --status-bg: #f1f1ee;
  --status-color: #69655e;
  --status-line: #ddd9d2;
}

.status-experiment {
  --status-bg: #f3eef8;
  --status-color: #6c5189;
  --status-line: #ded1e9;
}

.ops-version {
  display: inline-flex;
  padding: 5px 8px;
  border: 1px solid #edd7c6;
  border-radius: 7px;
  background: #fff5ed;
  color: #a4501d;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  font-weight: 900;
}

.ops-number {
  color: #5f5b54;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
}

.ops-number--strong {
  color: #383530;
  font-weight: 900;
}

.ops-owner {
  color: #58544e;
  font-size: 12px;
  font-weight: 800;
}

.ops-date {
  color: #7f7b74;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
}

.ops-row-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 8px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #625e58;
  cursor: pointer;
  font-size: 11px;
  font-weight: 850;
  white-space: nowrap;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;
}

.ops-row-action svg {
  width: 14px;
  height: 14px;
  transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-row-action.is-open svg {
  transform: rotate(180deg);
}

.ops-row-action:hover {
  background: #eef1e9;
  color: #40582f;
}

.ops-row-action--button {
  border: 1px solid #d7d4cd;
  background: #fff;
}

.ops-history-row td {
  height: auto;
  padding: 14px 18px 18px !important;
  background: #f7f8f4;
}

.ops-inline-history {
  overflow: hidden;
  border: 1px solid #dcd9d2;
  border-radius: 10px;
  background: #fff;
  animation: ops-history-in 360ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.survey-history-grid {
  display: grid;
  grid-template-columns: 90px 120px 110px minmax(220px, 1fr) 70px;
  align-items: center;
  gap: 10px;
}

.ops-inline-history__head {
  min-height: 35px;
  padding: 0 14px;
  border-bottom: 1px solid #e5e2dc;
  background: #f6f6f3;
  color: #817d76;
  font-size: 10px;
  font-weight: 850;
}

.ops-inline-history__item {
  min-height: 42px;
  padding: 0 14px;
  border-bottom: 1px solid #eeece7;
  color: #615d56;
  font-size: 12px;
  animation: ops-row-in 360ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-inline-history__item:last-child {
  border-bottom: 0;
}

.ops-inline-history__item strong {
  color: #5c5851;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.ops-inline-history__item strong.is-active {
  color: var(--ops-orange);
}

.ops-inline-history__item p {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-inline-history__item .is-number {
  text-align: right;
}

.ops-progress {
  display: flex;
  align-items: center;
  gap: 9px;
}

.ops-progress > div,
.ops-progress-track {
  height: 7px;
  flex: 1;
  overflow: hidden;
  border-radius: 999px;
  background: #e9ebe6;
}

.ops-progress i,
.ops-progress-track i {
  display: block;
  width: 0;
  height: 100%;
  border-radius: inherit;
  background: #658747;
  transform-origin: left center;
  animation: ops-progress-in 760ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-progress i.is-warning,
.ops-progress-track i.is-warning {
  background: #bf781a;
}

.ops-progress i.is-complete,
.ops-progress-track i.is-complete {
  background: #4e7950;
}

.ops-progress strong {
  width: 43px;
  flex: 0 0 auto;
  color: #4f4b45;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  font-weight: 850;
  text-align: right;
}

.ops-delta {
  color: #477442;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 900;
}

.ops-delta.is-negative {
  color: #b24b38;
}

.ops-field {
  display: grid;
  gap: 4px;
}

.ops-field strong {
  color: #4b4741;
  font-size: 12px;
  font-weight: 900;
}

.ops-field span {
  color: #918d85;
  font-size: 11px;
}

.ops-rating {
  color: #4b6537;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 900;
}

.ops-due {
  color: #5f5b54;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 850;
}

.ops-due.is-warning {
  color: #b06410;
}

.ops-toggle {
  position: relative;
  width: 40px;
  height: 23px;
  display: inline-flex;
  align-items: center;
  padding: 3px;
  border: 0;
  border-radius: 999px;
  background: #d4d6d0;
  cursor: pointer;
  transition: background 180ms ease, box-shadow 180ms ease;
}

.ops-toggle > span {
  width: 17px;
  height: 17px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(28, 31, 25, 0.22);
  transition: transform 230ms cubic-bezier(0.22, 1, 0.36, 1);
}

.ops-toggle.is-active {
  background: #547536;
  box-shadow: 0 0 0 3px rgba(84, 117, 54, 0.1);
}

.ops-toggle.is-active > span {
  transform: translateX(17px);
}

.ops-mobile-list {
  display: none;
}

.ops-empty {
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  text-align: center;
  animation: ops-fade-up 380ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-empty strong {
  font-size: 14px;
}

.ops-empty p {
  margin: 7px 0 0;
  color: #827e77;
  font-size: 12px;
}

.ops-empty button {
  margin-top: 14px;
  padding: 8px 12px;
  border: 1px solid #d6d3cc;
  border-radius: 8px;
  background: #fff;
  color: #425a31;
  cursor: pointer;
  font-size: 11px;
  font-weight: 850;
}

.ops-footer {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 18px;
  border-top: 1px solid var(--ops-line);
  background: #fbfbf9;
  color: #807c75;
  font-size: 11px;
}

.ops-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(27, 28, 24, 0.52);
  backdrop-filter: blur(5px);
  animation: ops-backdrop-in 220ms ease-out both;
}

.ops-modal {
  width: min(100%, 530px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.65);
  border-radius: 17px;
  background: #fff;
  box-shadow: 0 30px 80px rgba(22, 24, 20, 0.28);
  animation: ops-modal-in 420ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-modal--wide {
  width: min(100%, 760px);
}

.ops-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 24px 19px;
  border-bottom: 1px solid var(--ops-line);
  background: linear-gradient(120deg, #fff 0%, #f7f9f4 100%);
}

.ops-modal__header p {
  margin: 0;
  color: var(--ops-orange);
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.14em;
}

.ops-modal__header h2 {
  margin: 6px 0 0;
  color: #282521;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: -0.03em;
}

.ops-modal__header span {
  display: block;
  margin-top: 6px;
  color: #7f7b74;
  font-size: 12px;
}

.ops-modal__header > button {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  border-radius: 9px;
  background: #eef1ea;
  color: #66625b;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  transition: background 160ms ease, color 160ms ease, transform 160ms ease;
}

.ops-modal__header > button:hover {
  background: #e3e8dc;
  color: #354828;
  transform: rotate(5deg);
}

.ops-modal__body {
  display: grid;
  gap: 17px;
  padding: 22px 24px;
}

.ops-modal__body--scroll {
  max-height: 62vh;
  overflow-y: auto;
}

.ops-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 13px;
}

.ops-form-field {
  min-width: 0;
  display: grid;
  gap: 8px;
}

.ops-form-field > span {
  color: #4e4a44;
  font-size: 12px;
  font-weight: 850;
}

.ops-form-field input,
.ops-form-field select,
.ops-form-field textarea {
  width: 100%;
  padding: 0 13px;
  border: 1px solid #d5d2cb;
  border-radius: 9px;
  outline: 0;
  background: #fff;
  color: #37342f;
  font-size: 13px;
  transition: border-color 170ms ease, box-shadow 170ms ease;
}

.ops-form-field input,
.ops-form-field select {
  height: 43px;
}

.ops-form-field textarea {
  min-height: 90px;
  padding-top: 11px;
  padding-bottom: 11px;
  resize: vertical;
}

.ops-form-field input:focus,
.ops-form-field select:focus,
.ops-form-field textarea:focus {
  border-color: #879d71;
  box-shadow: 0 0 0 3px rgba(83, 116, 47, 0.11);
}

.ops-form-field input::placeholder,
.ops-form-field textarea::placeholder {
  color: #aaa69e;
}

.ops-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 24px;
  border-top: 1px solid var(--ops-line);
  background: #f8f8f5;
}

.ops-modal__footer button {
  height: 40px;
  padding: 0 15px;
  border-radius: 9px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 850;
  transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.ops-modal-cancel {
  border: 1px solid #d5d2cb;
  background: #fff;
  color: #625e58;
}

.ops-modal-submit {
  border: 1px solid var(--ops-olive);
  background: var(--ops-olive);
  color: #fff;
}

.ops-modal-submit:hover {
  background: #3d592a;
  box-shadow: 0 7px 15px rgba(48, 73, 31, 0.17);
  transform: translateY(-1px);
}

.ops-timeline {
  position: relative;
  display: grid;
  gap: 0;
  padding-left: 25px;
}

.ops-timeline::before {
  position: absolute;
  top: 8px;
  bottom: 8px;
  left: 5px;
  width: 1px;
  background: #d9d6cf;
  content: "";
}

.ops-timeline__item {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 18px;
  padding: 0 0 22px;
  animation: ops-row-in 400ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ops-timeline__item:last-child {
  padding-bottom: 0;
}

.ops-timeline__item > i {
  position: absolute;
  top: 5px;
  left: -24px;
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: #b9b6af;
  box-shadow: 0 0 0 4px #fff;
}

.ops-timeline__item > i.is-active {
  background: var(--ops-orange);
}

.ops-timeline__content > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ops-timeline__content > div strong {
  color: #3d3934;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  font-weight: 900;
}

.ops-timeline__content > div span {
  padding: 3px 7px;
  border-radius: 999px;
  background: #fff0e5;
  color: var(--ops-orange);
  font-size: 10px;
  font-weight: 850;
}

.ops-timeline__content h3 {
  margin: 7px 0 0;
  color: #45413b;
  font-size: 13px;
  font-weight: 800;
}

.ops-timeline__content p {
  margin: 6px 0 0;
  color: #8b877f;
  font-size: 11px;
}

.ops-timeline__metrics {
  display: flex;
  gap: 8px;
}

.ops-timeline__metrics > span {
  min-width: 74px;
  display: grid;
  gap: 4px;
  padding: 9px 11px;
  border-radius: 9px;
  background: #f4f6f1;
  text-align: center;
}

.ops-timeline__metrics small {
  color: #818079;
  font-size: 10px;
}

.ops-timeline__metrics strong {
  color: #456332;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
}

@media (max-width: 1279px) {
  .ops-table-wrap {
    display: none;
  }
  .ops-mobile-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    padding: 14px;
    background: #f7f7f4;
  }
  .ops-mobile-card {
    min-width: 0;
    padding: 15px;
    border: 1px solid #ddd9d2;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 3px 10px rgba(42, 40, 35, 0.035);
    animation: ops-row-in 450ms cubic-bezier(0.22, 1, 0.36, 1) both;
    transition: border-color 170ms ease, box-shadow 170ms ease, transform 170ms ease;
  }
  .ops-mobile-card:hover {
    border-color: #b8c3ad;
    box-shadow: 0 8px 19px rgba(45, 57, 36, 0.08);
    transform: translateY(-1px);
  }
  .ops-mobile-card__top,
  .expert-mobile-head,
  .expert-mobile-field,
  .ops-mobile-progress > div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .ops-mobile-card__top {
    align-items: flex-start;
  }
  .ops-mobile-card__title {
    margin-top: 13px;
  }
  .ops-mobile-card__title > strong {
    display: block;
    overflow: hidden;
    color: #302d29;
    font-size: 15px;
    font-weight: 900;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ops-mobile-card__title > p {
    margin: 5px 0 0;
    color: #8f8b84;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 11px;
  }
  .ops-mobile-metrics {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 14px;
    border-top: 1px solid #ebe8e2;
    border-left: 1px solid #ebe8e2;
  }
  .ops-mobile-metrics > div {
    min-width: 0;
    display: grid;
    gap: 5px;
    padding: 10px;
    border-right: 1px solid #ebe8e2;
    border-bottom: 1px solid #ebe8e2;
  }
  .ops-mobile-metrics span,
  .expert-mobile-field span,
  .ops-mobile-progress span {
    color: #858179;
    font-size: 11px;
  }
  .ops-mobile-metrics strong,
  .expert-mobile-field strong {
    overflow: hidden;
    color: #44403a;
    font-size: 12px;
    font-weight: 850;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ops-mobile-progress {
    display: grid;
    gap: 8px;
    margin-top: 14px;
  }
  .ops-mobile-progress strong {
    color: #4e4a44;
    font-size: 12px;
  }
  .ops-mobile-history-button {
    width: 100%;
    height: 39px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 13px;
    padding: 0 11px;
    border: 1px solid #d8d5ce;
    border-radius: 8px;
    background: #fafaf8;
    color: #535e49;
    cursor: pointer;
    font-size: 11px;
    font-weight: 850;
  }
  .ops-mobile-history-button svg {
    width: 15px;
    height: 15px;
    transition: transform 220ms cubic-bezier(0.22, 1, 0.36, 1);
  }
  .ops-mobile-history-button svg.is-open {
    transform: rotate(180deg);
  }
  .ops-mobile-history {
    display: grid;
    gap: 0;
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid #dfdcd5;
    border-radius: 9px;
    animation: ops-history-in 340ms cubic-bezier(0.22, 1, 0.36, 1) both;
  }
  .ops-mobile-history__item {
    padding: 10px 11px;
    border-bottom: 1px solid #ebe8e2;
  }
  .ops-mobile-history__item:last-child {
    border-bottom: 0;
  }
  .ops-mobile-history__item > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .ops-mobile-history__item strong {
    color: #55514b;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 11px;
  }
  .ops-mobile-history__item strong.is-active {
    color: var(--ops-orange);
  }
  .ops-mobile-history__item span,
  .ops-mobile-history__item p {
    color: #89857d;
    font-size: 10px;
  }
  .ops-mobile-history__item p {
    margin: 6px 0 0;
  }
  .expert-mobile-head .ops-identity {
    min-width: 0;
  }
  .expert-mobile-field {
    margin-top: 14px;
    padding: 10px 11px;
    border-radius: 8px;
    background: #f4f6f1;
  }
}
@media (max-width: 960px) {
  .ops-toolbar {
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
  }
  .ops-tabs {
    overflow-x: auto;
    scrollbar-width: none;
  }
  .ops-tabs::-webkit-scrollbar {
    display: none;
  }
  .ops-search {
    width: 100%;
  }
  .ops-filter-group {
    width: 100%;
  }
  .ops-filter-group .ops-search {
    flex: 1;
  }
}
@media (max-width: 767px) {
  .ops-shell {
    padding-right: 16px;
    padding-left: 16px;
  }
  .ops-header__inner {
    height: auto;
    min-height: 132px;
    align-items: flex-end;
    padding-top: 18px;
    padding-bottom: 17px;
  }
  .ops-heading {
    flex: 1;
  }
  .ops-eyebrow {
    font-size: 9px;
  }
  .ops-heading h1 {
    font-size: 21px;
  }
  .ops-heading > p {
    max-width: 245px;
    font-size: 11px;
  }
  .ops-header-status {
    display: none;
  }
  .ops-primary-button {
    width: 41px;
    padding: 0;
  }
  .ops-primary-button > span {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  .ops-content {
    gap: 14px;
    padding-top: 14px;
    padding-bottom: 18px;
  }
  .ops-summary,
  .ops-panel {
    border-radius: 13px;
  }
  .ops-summary {
    display: block;
  }
  .ops-summary__intro {
    min-height: 68px;
    padding: 0 14px;
    border-right: 0;
    border-bottom: 1px solid var(--ops-line-soft);
  }
  .ops-summary__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .ops-stat {
    min-height: 68px;
    padding: 0 14px;
    border-bottom: 1px solid var(--ops-line-soft);
  }
  .ops-stat:nth-child(even) {
    border-right: 0;
  }
  .ops-stat:nth-child(3),
  .ops-stat:nth-child(4) {
    border-bottom: 0;
  }
  .ops-stat strong {
    font-size: 21px;
  }
  .ops-stat > span {
    font-size: 10px;
  }
  .ops-toolbar {
    padding: 12px;
  }
  .ops-tabs {
    width: 100%;
  }
  .ops-tab {
    flex: 1;
    min-width: 0;
    padding: 0 8px;
    font-size: 10px;
  }
  .ops-tabs--wide .ops-tab em {
    display: none;
  }
  .ops-toolbar--experts .ops-filter-group {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 128px;
  }
  .ops-select {
    width: 100%;
  }
  .ops-check {
    align-self: flex-start;
  }
  .ops-result-meta {
    min-height: 48px;
    padding: 6px 12px;
  }
  .ops-mobile-list {
    grid-template-columns: 1fr;
    padding: 10px;
  }
  .ops-mobile-card {
    padding: 14px;
  }
  .ops-footer {
    padding: 0 12px;
  }
  .ops-footer span:last-child {
    display: none;
  }
  .ops-modal-backdrop {
    align-items: flex-end;
    padding: 0;
  }
  .ops-modal,
  .ops-modal--wide {
    width: 100%;
    max-height: 92vh;
    overflow-y: auto;
    border-radius: 19px 19px 0 0;
    animation-name: ops-sheet-in;
  }
  .ops-modal__header,
  .ops-modal__body,
  .ops-modal__footer {
    padding-right: 18px;
    padding-left: 18px;
  }
  .ops-form-grid {
    grid-template-columns: 1fr;
  }
  .ops-timeline__item {
    grid-template-columns: 1fr;
  }
  .ops-timeline__metrics {
    justify-content: flex-start;
  }
}
@media (max-width: 420px) {
  .ops-header__inner {
    gap: 12px;
  }
  .ops-heading > p {
    max-width: 255px;
  }
  .ops-toolbar--experts .ops-filter-group {
    grid-template-columns: 1fr;
  }
}
@keyframes ops-fade-up {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-panel-in {
  from {
    opacity: 0;
    transform: translateY(12px);
    box-shadow: 0 2px 5px rgba(42, 40, 35, 0);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-stat-in {
  from {
    opacity: 0;
    transform: translateX(-8px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes ops-row-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-progress-in {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes ops-history-in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes ops-live {
  0% {
    opacity: 0.9;
    transform: scale(0.7);
  }
  65%, 100% {
    opacity: 0;
    transform: scale(1.55);
  }
}
@keyframes ops-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes ops-modal-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes ops-sheet-in {
  from {
    opacity: 0;
    transform: translateY(35px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .ops-heading,
  .ops-header__actions,
  .ops-summary,
  .ops-panel,
  .ops-stat,
  .ops-row,
  .ops-mobile-card,
  .ops-empty,
  .ops-inline-history,
  .ops-inline-history__item,
  .ops-mobile-history,
  .ops-progress i,
  .ops-progress-track i,
  .ops-header-status i::after,
  .ops-modal-backdrop,
  .ops-modal,
  .ops-timeline__item {
    animation: none !important;
  }
  .ops-primary-button,
  .ops-primary-button svg,
  .ops-row,
  .ops-mobile-card,
  .ops-mark,
  .ops-avatar,
  .ops-toggle,
  .ops-toggle > span,
  .ops-row-action svg,
  .ops-mobile-history-button svg {
    transition: none !important;
  }
}
:host {
  display: block;
  height: 100%;
}

/* Expert capacity assignment board selected design */
.expert-capacity-page {
  --ec-ink: #202124;
  --ec-muted: #74767c;
  --ec-soft: #f5f6f7;
  --ec-line: #dfe1e5;
  --ec-orange: #e4572e;
  --ec-green: #3f7d3a;
  --ec-amber: #d88708;
  --ec-blue: #397bd1;
  --ec-violet: #68499a;
  min-height: 100%;
  overflow-x: hidden;
  color: var(--ec-ink);
  background: #f4f5f6;
}

.expert-capacity-page *,
.expert-capacity-page *::before,
.expert-capacity-page *::after {
  box-sizing: border-box;
}

.expert-capacity-page button,
.expert-capacity-page input,
.expert-capacity-page select {
  font: inherit;
}

.expert-capacity-header {
  z-index: 20;
  border: 0;
  background: #fff;
}

.expert-capacity-heading {
  min-width: 0;
}

.expert-capacity-eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #7c7f85;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.11em;
}

.expert-capacity-eyebrow em {
  color: #b5b7bb;
  font-style: normal;
}

.expert-capacity-eyebrow strong {
  color: var(--ec-orange);
  font-weight: 700;
}

.expert-capacity-heading h1 {
  margin: 7px 0 0;
}

.expert-capacity-heading p {
  margin: 8px 0 0;
  color: #6f7278;
  font-size: 14px;
  line-height: 1.45;
}

.expert-capacity-header__actions {
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 0 0 auto;
}

.expert-capacity-health {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: #526b47;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.expert-capacity-health i {
  color: var(--ec-green);
  font-size: 12px;
}

.expert-capacity-header__actions time {
  color: #61646a;
  font-size: 12px;
  white-space: nowrap;
}

.expert-capacity-create {
  min-width: 118px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 18px;
  border: 0;
  background: var(--ec-orange);
  color: #fff;
  box-shadow: 0 8px 18px rgba(228, 87, 46, 0.18);
  cursor: pointer;
  transition: transform 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.expert-capacity-create:hover {
  background: #cc4723;
  box-shadow: 0 11px 22px rgba(228, 87, 46, 0.24);
  transform: translateY(-1px);
}

.expert-capacity-create:active {
  transform: translateY(0) scale(0.98);
}

.expert-capacity-strip {
  min-height: 86px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid var(--ec-line);
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(32, 33, 36, 0.04);
}

.expert-capacity-strip button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 18px 26px;
  border: 0;
  background: transparent;
  color: #2f3135;
  cursor: pointer;
  box-shadow: inset -1px 0 0 #e5e7ea;
  transition: background 160ms ease, color 160ms ease;
}

.expert-capacity-strip button:last-child {
  box-shadow: none;
}

.expert-capacity-strip button:hover,
.expert-capacity-strip button.is-active {
  background: #fafafa;
}

.expert-capacity-strip button:nth-child(1) > i {
  color: var(--ec-green);
}

.expert-capacity-strip button:nth-child(2) > i {
  color: var(--ec-amber);
}

.expert-capacity-strip button:nth-child(3) > i {
  color: var(--ec-violet);
}

.expert-capacity-strip button > i {
  width: 32px;
  font-size: 27px;
  text-align: center;
}

.expert-capacity-strip button > span {
  display: grid;
  gap: 3px;
  text-align: left;
}

.expert-capacity-strip small {
  color: #64676d;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-strip strong {
  color: #1f2023;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}

.expert-capacity-strip strong em {
  margin-inline-start: 3px;
  color: #85888e;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.expert-capacity-shell {
  border: 0;
  background: transparent;
}

.expert-capacity-filters {
  min-width: 0;
  padding: 16px 0 0;
  background: transparent;
  box-shadow: none;
}

.expert-capacity-filters > header {
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 0 0 22px;
}

.expert-capacity-filters h2 {
  margin: 0;
  color: #25272b;
  font-size: 16px;
  font-weight: 700;
}

.expert-capacity-filters > header button {
  min-width: 66px;
  min-height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 9px;
  border: 1px solid #d6d9dd;
  background: #fff;
  color: #575a60;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 150ms ease, background 150ms ease, color 150ms ease;
}

.expert-capacity-filters > header button:not(:disabled):hover {
  border-color: #aeb2b8;
  background: #f5f6f7;
  color: #292b2f;
}

.expert-capacity-filters > header button i {
  font-size: 12px;
}

.expert-capacity-filters > header button:disabled {
  border-color: #e2e4e7;
  background: #f5f6f7;
  color: #b5b8bd;
  cursor: default;
}

.expert-capacity-filter-field {
  display: grid;
  gap: 7px;
  margin: 0 0 18px;
}

.expert-capacity-filter-field > span {
  color: #55585e;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-filter-field select {
  width: 100%;
  height: 36px;
  padding: 0 10px;
  border: 1px solid #d9dce0;
  border-radius: 4px;
  outline: 0;
  background: #fff;
  color: #4d5056;
  cursor: pointer;
  font-size: 12px;
}

.expert-capacity-filter-field select:focus-visible {
  border-color: #969aa2;
  box-shadow: 0 0 0 3px rgba(57, 123, 209, 0.12);
}

.expert-capacity-check {
  min-height: 58px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 7px;
  padding: 10px 11px;
  border: 1px solid #d9dce0;
  border-radius: 4px;
  background: #fff;
  color: #4f5258;
  cursor: pointer;
  font-size: 12px;
  transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease;
}

.expert-capacity-check input {
  position: absolute;
  opacity: 0;
}

.expert-capacity-check__box {
  width: 21px;
  height: 21px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border: 1px solid #bec2c8;
  border-radius: 3px;
  background: #fff;
  color: transparent;
  font-size: 12px;
}

.expert-capacity-check:hover {
  border-color: #aeb3ba;
  background: #f8f9f9;
}

.expert-capacity-check:has(input:checked) {
  border-color: #89a784;
  background: #f3f8f1;
  box-shadow: inset 3px 0 0 var(--ec-green);
}

.expert-capacity-check input:focus-visible + .expert-capacity-check__box {
  box-shadow: 0 0 0 3px rgba(63, 125, 58, 0.16);
}

.expert-capacity-check input:checked + .expert-capacity-check__box {
  border-color: var(--ec-green);
  background: var(--ec-green);
  color: #fff;
}

.expert-capacity-check__copy {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.expert-capacity-check__copy strong {
  color: #41444a;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.expert-capacity-check__copy small {
  color: #8a8d93;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
  white-space: nowrap;
}

.expert-capacity-main {
  min-width: 0;
  overflow: hidden;
  border-radius: 6px;
  background: #fff;
}

.expert-capacity-toolbar {
  min-height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 11px 16px;
  box-shadow: inset 0 -1px 0 #e3e5e8;
}

.expert-capacity-search {
  border: 1px solid #dadddf;
  background: #fff;
  color: #9b9ea4;
}

.expert-capacity-search input {
  width: 100%;
  min-width: 0;
  color: #25272b;
  font-size: 12px;
}

.expert-capacity-search input::placeholder {
  color: #a1a4aa;
}

.expert-capacity-search button {
  border: 0;
  background: transparent;
  color: #8b8e94;
  cursor: pointer;
}

.expert-capacity-sort {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #686b71;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-sort select {
  height: 36px;
  border: 1px solid #dadddf;
  border-radius: 4px;
  background: #fff;
  color: #4c4f55;
}

.expert-capacity-sort select {
  min-width: 148px;
  padding: 0 10px;
}

.expert-capacity-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.expert-capacity-table th,
.expert-capacity-table td {
  text-align: left;
  vertical-align: middle;
}

.expert-capacity-table th {
  height: 47px;
  padding: 0 10px;
  background: #f7f7f7;
  color: #5f6268;
  box-shadow: inset 0 -1px 0 #dfe1e4;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-table th small {
  display: block;
  margin-top: 2px;
  color: #8b8e94;
  font-size: 12px;
}

.expert-capacity-table th:nth-child(1) {
  width: 22%;
}

.expert-capacity-table th:nth-child(2) {
  width: 10%;
}

.expert-capacity-table th:nth-child(3) {
  width: 12%;
}

.expert-capacity-table th:nth-child(4) {
  width: 12%;
}

.expert-capacity-table th:nth-child(5) {
  width: 12%;
}

.expert-capacity-table th:nth-child(6) {
  width: 9%;
}

.expert-capacity-table th:nth-child(7) {
  width: 12%;
}

.expert-capacity-table th:nth-child(8) {
  width: 11%;
}

.expert-capacity-row {
  min-height: 105px;
  background: #fff;
  box-shadow: inset 0 -1px 0 #e5e7ea;
  animation: expert-row-in 420ms cubic-bezier(0.22, 1, 0.36, 1) both;
  transition: background 150ms ease, opacity 150ms ease;
}

.expert-capacity-row:hover,
.expert-capacity-row.is-expanded {
  background: #fcfcfc;
}

.expert-capacity-row.is-expanded {
  box-shadow: inset 0 0 0 1px #aeb4bd;
}

.expert-capacity-row.is-inactive {
  opacity: 0.58;
}

.expert-capacity-row td {
  padding: 17px 10px;
}

.expert-capacity-identity {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 11px;
}

.expert-capacity-avatar {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 999px;
  background: #e9f2fb;
  color: #2865a8;
  font-size: 15px;
  font-weight: 700;
}

.expert-capacity-identity > div {
  min-width: 0;
  display: grid;
  gap: 5px;
}

.expert-capacity-identity strong {
  overflow: hidden;
  color: #25272b;
  font-size: 13px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.expert-capacity-identity strong i {
  width: 7px;
  height: 7px;
  display: inline-block;
  margin-inline-start: 6px;
  border-radius: 999px;
  background: #b8bbc0;
}

.expert-capacity-identity strong i.is-live {
  background: var(--ec-green);
}

.expert-capacity-identity p {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 0;
}

.expert-capacity-identity p span {
  max-width: 105px;
  overflow: hidden;
  padding: 3px 6px;
  border-radius: 3px;
  background: #f0f1f2;
  color: #5e6167;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.expert-capacity-project-count,
.expert-capacity-assigned {
  display: block;
  color: #2f3135;
  font-size: 14px;
  font-weight: 700;
}

.expert-capacity-project-count em,
.expert-capacity-assigned em {
  margin-inline-start: 2px;
  color: #686b71;
  font-size: 12px;
  font-style: normal;
}

.expert-capacity-row td > small {
  display: block;
  margin-top: 5px;
  color: #92959b;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-meter,
.expert-capacity-progress {
  display: grid;
  gap: 5px;
}

.expert-capacity-meter strong,
.expert-capacity-progress strong {
  color: #2d3035;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-meter > div,
.expert-capacity-progress > div {
  height: 5px;
  overflow: hidden;
  border-radius: 999px;
  background: #e7e9ec;
}

.expert-capacity-meter > div i,
.expert-capacity-progress > div i {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: var(--ec-blue);
  transition: width 260ms ease;
}

.expert-capacity-meter small,
.expert-capacity-progress small {
  color: #8f9298;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-meter.is-high small {
  color: var(--ec-green);
}

.expert-capacity-meter.is-medium small {
  color: #a96908;
}

.expert-capacity-meter.is-low small {
  color: #c2452a;
}

.expert-capacity-meter.is-medium > div i {
  background: var(--ec-amber);
}

.expert-capacity-meter.is-low > div i {
  background: var(--ec-orange);
}

.expert-capacity-progress > div i {
  background: var(--ec-green);
}

.expert-capacity-rating {
  display: grid;
  gap: 4px;
}

.expert-capacity-rating strong {
  color: #2c2e32;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.expert-capacity-rating strong i {
  margin-inline-end: 4px;
  color: #ef7b16;
  font-size: 12px;
}

.expert-capacity-rating small {
  color: #91949a;
  font-size: 12px;
  white-space: nowrap;
}

.expert-capacity-row time {
  color: #55585e;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.expert-capacity-row time.is-immediate {
  color: var(--ec-green);
  font-weight: 700;
}

.expert-capacity-actions {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 28px 22px;
  align-items: center;
  gap: 4px;
}

.expert-capacity-actions button {
  height: 34px;
  border: 1px solid #d7dade;
  background: #fff;
  color: #373a40;
  cursor: pointer;
  white-space: nowrap;
}

.expert-capacity-actions button:hover {
  border-color: #aeb2b9;
  background: #f7f7f7;
}

.expert-capacity-actions button:nth-child(2),
.expert-capacity-actions button:nth-child(3) {
  padding: 0;
  border: 0;
  background: transparent;
}

.expert-capacity-expanded {
  background: #fbfbfb;
  box-shadow: inset 0 -1px 0 #e2e4e7;
}

.expert-capacity-expanded td {
  padding: 0 10px 16px;
}

.expert-assignment-panel {
  display: grid;
  grid-template-columns: minmax(0, 1.75fr) minmax(190px, 0.9fr) minmax(180px, 0.8fr);
  overflow: hidden;
  border: 1px solid #d9dce0;
  border-radius: 5px;
  background: #fff;
}

.expert-assignment-panel > section {
  min-width: 0;
  padding: 18px 20px;
  box-shadow: inset -1px 0 0 #e6e8ea;
}

.expert-assignment-panel > section:nth-child(3) {
  box-shadow: none;
}

.expert-assignment-task > header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.expert-assignment-task > header strong {
  color: var(--ec-green);
  font-size: 12px;
  font-weight: 700;
}

.expert-assignment-task > header span {
  padding: 4px 7px;
  border-radius: 3px;
  background: #edf4e9;
  color: #4d733b;
  font-size: 12px;
  font-weight: 700;
}

.expert-assignment-task article {
  padding: 14px 16px;
  border: 1px solid #dfe1e4;
  border-radius: 4px;
  background: #fff;
}

.expert-assignment-task h3 {
  margin: 0 0 12px;
  color: #282a2f;
  font-size: 13px;
  font-weight: 700;
}

.expert-assignment-task dl {
  display: grid;
  gap: 7px;
  margin: 0;
}

.expert-assignment-task dl div {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 10px;
}

.expert-assignment-task dt,
.expert-assignment-task dd {
  margin: 0;
  font-size: 12px;
}

.expert-assignment-task dt {
  color: #777a80;
}

.expert-assignment-task dd {
  color: #50535a;
  font-weight: 700;
}

.expert-assignment-score {
  display: grid;
  align-content: start;
  gap: 7px;
}

.expert-assignment-score > span {
  color: #60636a;
  font-size: 12px;
  font-weight: 700;
}

.expert-assignment-score > strong {
  color: var(--ec-green);
  font-size: 25px;
  font-weight: 700;
  line-height: 1;
}

.expert-assignment-score > strong em {
  font-size: 13px;
  font-style: normal;
}

.expert-assignment-score ul {
  display: grid;
  gap: 8px;
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
}

.expert-assignment-score li {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  color: #65686e;
  font-size: 12px;
  line-height: 1.35;
}

.expert-assignment-score li i {
  margin-top: 1px;
  color: var(--ec-green);
}

.expert-assignment-actions {
  display: grid;
  align-content: center;
  gap: 10px;
}

.expert-assignment-actions button {
  min-height: 42px;
  padding: 0 14px;
  border: 1px solid #d9dce0;
  background: #fff;
  color: #404349;
  cursor: pointer;
}

.expert-assignment-actions button:first-child {
  border-color: var(--ec-orange);
  background: var(--ec-orange);
  color: #fff;
  box-shadow: 0 8px 17px rgba(228, 87, 46, 0.16);
}

.expert-assignment-panel > footer {
  grid-column: 1/-1;
  min-height: 42px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 20px;
  background: #fbfbfb;
  box-shadow: inset 0 1px 0 #e7e9ec;
}

.expert-assignment-panel > footer strong {
  margin-inline-end: 5px;
  color: #4f5258;
  font-size: 12px;
  font-weight: 700;
}

.expert-assignment-panel > footer span {
  padding: 4px 7px;
  border-radius: 3px;
  background: #eff0f1;
  color: #62656b;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-empty {
  min-height: 280px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 10px;
  padding: 44px 22px;
  text-align: center;
}

.expert-capacity-empty > i {
  color: #b1b4b9;
  font-size: 31px;
}

.expert-capacity-empty strong {
  color: #303238;
  font-size: 14px;
  font-weight: 700;
}

.expert-capacity-empty p {
  margin: 0;
  color: #85888e;
  font-size: 12px;
  line-height: 1.5;
}

.expert-capacity-empty button {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 3px;
  padding: 0 13px;
  border: 1px solid #d4d7db;
  background: #fff;
  color: #35383e;
  cursor: pointer;
}

.expert-capacity-footer > span {
  color: #686b71;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-footer nav {
  display: flex;
  align-items: center;
  gap: 7px;
}

.expert-capacity-footer nav button {
  width: 32px;
  height: 32px;
  border: 1px solid #d9dce0;
  background: #fff;
  color: #62656b;
  cursor: pointer;
}

.expert-capacity-footer nav button.is-active {
  border-color: var(--ec-orange);
  color: var(--ec-orange);
}

@keyframes expert-row-in {
  from {
    opacity: 0;
    transform: translateY(7px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.expert-capacity-strip {
  border-radius: 0;
  box-shadow: none;
}

.expert-capacity-strip button {
  box-shadow: none;
}

.expert-capacity-strip button + button {
  border-inline-start: 1px solid var(--ec-line);
}

.expert-capacity-shell {
  border: 0;
  background: transparent;
}

.expert-capacity-filters {
  border-inline-end: 0;
  background: transparent;
  box-shadow: none;
}

.expert-capacity-toolbar {
  border-block-end: 1px solid #e3e5e8;
  box-shadow: none;
}

.expert-capacity-search input {
  padding: 0;
  box-shadow: none !important;
}

.expert-capacity-table th {
  border-block-end: 1px solid #dfe1e4;
  box-shadow: none;
}

.expert-capacity-row,
.expert-capacity-row.is-expanded,
.expert-capacity-expanded {
  box-shadow: none;
}

.expert-capacity-row td {
  border-block-end: 1px solid #e5e7ea;
}

.expert-capacity-row.is-expanded {
  background: #fcfcfc;
}

.expert-capacity-row.is-expanded td {
  border-block-end: 0;
}

.expert-capacity-expanded td {
  border-block-end: 1px solid #e2e4e7;
}

.expert-assignment-panel {
  border-radius: 0;
}

.expert-assignment-panel > section {
  box-shadow: none;
}

.expert-assignment-panel > section + section {
  border-inline-start: 1px solid #e6e8ea;
}

.expert-capacity-footer {
  border-block-start: 1px solid #e4e6e9;
}

.ops-modal {
  width: min(720px, 100vw - 32px);
}

.ops-user-search-field {
  grid-column: 1/-1;
  display: grid;
  gap: 8px;
}

.ops-user-search-control {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 46px;
  padding: 0 14px;
  border: 1px solid #d8dbd3;
  border-radius: 4px;
  background: #fff;
}

.ops-user-search-control input {
  flex: 1;
  min-width: 0;
  padding: 0;
  border: 0 !important;
  outline: 0;
  background: transparent;
  box-shadow: none !important;
}

.ops-user-results {
  grid-column: 1/-1;
  display: grid;
  overflow: hidden;
  border: 1px solid #e0e2dd;
  border-radius: 4px;
}

.ops-user-option {
  min-height: 64px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border: 0;
  background: #fff;
  text-align: start;
}

.ops-user-option + .ops-user-option {
  border-block-start: 1px solid #e0e2dd;
}

.ops-user-option:hover:not(:disabled),
.ops-user-option[aria-selected=true] {
  background: #f7faf2;
}

.ops-user-option:disabled {
  opacity: 0.58;
  cursor: not-allowed;
}

.ops-user-avatar {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 4px;
  background: #f0f2ea;
  color: #53633f;
}

.ops-user-copy {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.ops-user-copy strong,
.ops-user-copy small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-user-copy small {
  color: #7b8078;
}

.ops-role-tag {
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 12px;
}

.ops-role-tag.is-reviewer {
  background: #eaf4e7;
  color: #436734;
}

.ops-role-tag.is-admin {
  background: #f2f2f0;
  color: #666;
}

.ops-selected-user {
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #f7faf2;
  color: #3f6435;
}

.ops-selected-user > span {
  flex: 1;
  display: grid;
  gap: 2px;
}

.ops-selected-user small {
  color: #6d7768;
}

.ops-selected-user em {
  font-style: normal;
}

.ops-user-empty {
  padding: 24px;
  color: #7d817c;
  text-align: center;
}

.ops-modal-submit {
  border: 1px solid #e4572e !important;
  background: #e4572e !important;
  color: #fff !important;
}

.ops-modal-submit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

@media (max-width: 1180px) {
  .expert-capacity-header__actions {
    gap: 12px;
  }
  .expert-capacity-header__actions time {
    display: none;
  }
  .expert-capacity-table th:nth-child(6),
  .expert-capacity-table td:nth-child(6) {
    display: none;
  }
  .expert-capacity-table th:nth-child(1) {
    width: 25%;
  }
  .expert-capacity-table th:nth-child(2) {
    width: 10%;
  }
  .expert-capacity-table th:nth-child(3) {
    width: 13%;
  }
  .expert-capacity-table th:nth-child(4) {
    width: 13%;
  }
  .expert-capacity-table th:nth-child(5) {
    width: 14%;
  }
  .expert-capacity-table th:nth-child(7) {
    width: 13%;
  }
  .expert-capacity-table th:nth-child(8) {
    width: 12%;
  }
}
@media (max-width: 980px) {
  .expert-capacity-filters {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr)) auto;
    align-items: end;
    gap: 12px;
    padding: 14px 0;
    box-shadow: none;
  }
  .expert-capacity-filters > header {
    grid-column: 1/-1;
    min-height: 28px;
    margin: 0;
    padding: 0 0 10px;
  }
  .expert-capacity-filter-field {
    margin: 0;
  }
  .expert-capacity-check {
    min-height: 58px;
    margin: 0;
  }
}
@media (max-width: 820px) {
  .expert-capacity-health {
    display: none;
  }
  .expert-capacity-strip {
    grid-template-columns: 1fr;
  }
  .expert-capacity-strip button {
    justify-content: flex-start;
    padding-inline: 24px;
    box-shadow: inset 0 -1px 0 #e5e7ea;
  }
  .expert-capacity-strip button:last-child {
    box-shadow: none;
  }
  .expert-capacity-filters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .expert-capacity-check {
    grid-column: 1/-1;
  }
  .expert-capacity-mobile article {
    display: grid;
    gap: 14px;
    padding: 18px;
    box-shadow: inset 0 -1px 0 #e5e7ea;
  }
  .expert-capacity-mobile article > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .expert-capacity-mobile article > header > button {
    width: 34px;
    height: 34px;
    border: 1px solid #d9dce0;
    background: #fff;
    color: #595c62;
  }
  .expert-capacity-mobile dl {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin: 0;
  }
  .expert-capacity-mobile dl div {
    padding: 10px;
    background: #f6f7f8;
  }
  .expert-capacity-mobile dt,
  .expert-capacity-mobile dd {
    margin: 0;
  }
  .expert-capacity-mobile dt {
    color: #878a90;
    font-size: 12px;
  }
  .expert-capacity-mobile dd {
    margin-top: 5px;
    color: #2f3135;
    font-size: 12px;
    font-weight: 700;
  }
  .expert-capacity-mobile__assign {
    min-height: 38px;
    border: 0;
    background: var(--ec-orange);
    color: #fff;
  }
  .expert-capacity-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .expert-capacity-sort {
    justify-content: flex-end;
  }
}
@media (max-width: 560px) {
  .expert-capacity-eyebrow {
    font-size: 12px;
  }
  .expert-capacity-create {
    min-width: 42px;
    width: 42px;
    padding: 0;
  }
  .expert-capacity-content {
    padding-block-start: 14px;
  }
  .expert-capacity-filters {
    grid-template-columns: 1fr;
  }
  .expert-capacity-filters > header,
  .expert-capacity-check {
    grid-column: auto;
  }
  .expert-capacity-sort span {
    display: none;
  }
  .expert-capacity-sort select {
    width: 100%;
  }
  .expert-capacity-mobile dl {
    grid-template-columns: 1fr;
  }
}
/* Expert management frameless surfaces */
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-shell {
  border: 0 !important;
  background: transparent !important;
}

:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-filters {
  align-self: start;
  padding: 18px 16px;
  border: 1px solid #dfe2db !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-main {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #dfe2db !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  box-shadow: none !important;
}

:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-toolbar {
  border: 0 !important;
  box-shadow: inset 0 -1px 0 #e3e5e8 !important;
}

:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-table thead {
  border: 0 !important;
  box-shadow: inset 0 -1px 0 #dfe1e4 !important;
}

:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-footer {
  border: 0 !important;
}

@media (max-width: 980px) {
  :host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-filters {
    padding: 14px;
  }
}
/* Compact expert filters: the list now owns the full content width. */
.expert-capacity-main,
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-main {
  width: 100%;
}

.expert-capacity-toolbar {
  gap: 14px;
  padding: 11px 14px;
}

.expert-compact-filters {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.expert-compact-filter {
  position: relative;
  min-width: 112px;
  height: 38px;
  display: flex;
  align-items: center;
  border: 1px solid #dadddf;
  border-radius: 4px;
  background: #fff;
  color: #777b81;
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.expert-compact-filter--field {
  min-width: 136px;
}

.expert-compact-filter:focus-within {
  border-color: #8c9987;
  box-shadow: 0 0 0 3px rgba(87, 112, 78, 0.12);
}

.expert-compact-filter > i {
  position: absolute;
  inset-inline-start: 10px;
  z-index: 1;
  font-size: 12px;
  pointer-events: none;
}

.expert-compact-filter select {
  width: 100%;
  height: 100%;
  padding: 0 26px 0 28px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #4d5056;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
}

.expert-compact-toggle {
  position: relative;
  min-width: 88px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 11px;
  border: 1px solid #dadddf;
  border-radius: 4px;
  background: #fff;
  color: #60646a;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  transition: border-color 150ms ease, background 150ms ease, color 150ms ease;
}

.expert-compact-toggle:hover {
  border-color: #aeb3ba;
  background: #f8f9f8;
}

.expert-compact-toggle.is-active {
  border-color: #82977a;
  background: #eef4eb;
  color: #536b4b;
}

.expert-compact-toggle input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.expert-compact-toggle:has(input:focus-visible) {
  box-shadow: 0 0 0 3px rgba(87, 112, 78, 0.14);
}

.expert-compact-filter-reset {
  width: 38px;
  height: 38px;
  display: inline-grid;
  place-items: center;
  flex: 0 0 38px;
  border: 1px solid #dadddf;
  background: #fff;
  color: #73777d;
  cursor: pointer;
}

.expert-compact-filter-reset:hover {
  border-color: #aeb3ba;
  background: #f4f5f4;
  color: #33363a;
}

@media (max-width: 1420px) {
  .expert-capacity-toolbar {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .expert-capacity-sort {
    margin-inline-start: auto;
  }
}
@media (max-width: 1060px) {
  .expert-compact-filters {
    flex-wrap: wrap;
  }
}
@media (max-width: 680px) {
  .expert-capacity-toolbar {
    padding: 10px;
  }
  .expert-compact-filters {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .expert-compact-filter,
  .expert-compact-filter--field,
  .expert-compact-toggle {
    width: 100%;
    min-width: 0;
  }
  .expert-compact-filter-reset {
    width: 100%;
  }
}
/* Expert compact filters — custom single-border dropdowns. */
.expert-capacity-toolbar {
  position: relative;
  z-index: 30;
  overflow: visible;
}

.expert-compact-filter {
  overflow: visible;
}

.expert-compact-filter.is-open {
  z-index: 40;
  border-color: #7c9273;
  background: #fbfcfa;
  box-shadow: 0 0 0 3px rgba(87, 112, 78, 0.12);
}

.expert-compact-filter__trigger {
  width: 100%;
  height: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 9px 0 28px;
  color: #4d5056;
  background: transparent;
  border: 0 !important;
  outline: 0;
  box-shadow: none !important;
  cursor: pointer;
  text-align: left;
}

.expert-compact-filter__trigger > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.expert-compact-filter__trigger .expert-compact-filter__caret {
  flex: 0 0 auto;
  color: #90959a;
  transition: transform 150ms ease;
}

.expert-compact-filter.is-open .expert-compact-filter__caret {
  color: #5c7552;
  transform: rotate(180deg);
}

.expert-compact-filter__menu {
  position: absolute;
  top: calc(100% + 7px);
  left: -1px;
  z-index: 80;
  width: max(100%, 152px);
  display: grid;
  gap: 2px;
  padding: 5px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #d9ded7;
  border-radius: 8px;
  box-shadow: 0 12px 28px rgba(42, 51, 38, 0.16);
}

.expert-compact-filter:nth-child(4) .expert-compact-filter__menu {
  right: -1px;
  left: auto;
}

.expert-compact-filter__menu button {
  width: 100%;
  min-height: 32px;
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr);
  align-items: center;
  gap: 7px;
  padding: 0 9px;
  color: #50554f;
  background: transparent;
  border: 0 !important;
  outline: 0;
  box-shadow: none !important;
  cursor: pointer;
  text-align: left;
}

.expert-compact-filter__menu button i {
  color: transparent;
  font-size: 12px;
}

.expert-compact-filter__menu button:hover,
.expert-compact-filter__menu button:focus-visible {
  color: #415d38;
  background: #f0f4ed;
}

.expert-compact-filter__menu button.is-selected {
  color: #354f2e;
  background: #e9f0e5;
}

.expert-compact-filter__menu button.is-selected i {
  color: #55754b;
}

@media (max-width: 680px) {
  .expert-compact-filter__menu {
    width: max(100%, 160px);
  }
}
/* -------------------------------------------------------------------------- */
/* Premium expert operations workspace — authoritative directory styles       */
/* -------------------------------------------------------------------------- */
.expert-capacity-page {
  --expert-ink: #242824;
  --expert-muted: #737a73;
  --expert-line: #dfe3dc;
  --expert-line-soft: #eceee9;
  --expert-canvas: #f4f5f1;
  --expert-surface: #ffffff;
  --expert-green: #58705c;
  --expert-green-soft: #edf3eb;
  --expert-orange: #d85a36;
  min-height: 100vh;
  color: var(--expert-ink);
  background: var(--expert-canvas);
}

.expert-capacity-page .ops-shell,
.expert-capacity-page .expert-capacity-header__inner,
.expert-capacity-page .expert-capacity-content.ops-shell {
  width: min(100% - 64px, 1480px);
  max-width: 1480px;
  margin-inline: auto;
  padding-inline: 0;
}

.expert-capacity-page .expert-capacity-header {
  border-bottom: 1px solid #e1e3dc;
  background: #fafbf8;
}

.expert-capacity-page .expert-capacity-heading {
  display: grid;
  gap: 5px;
  min-width: 0;
}

.expert-capacity-page .expert-capacity-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  color: var(--expert-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
}

.expert-capacity-page .expert-capacity-eyebrow i {
  font-size: 12px;
}

.expert-capacity-page .reviewops-page-title {
  margin: 0;
}

.expert-capacity-page .expert-capacity-heading > p {
  margin: 0;
  color: #6d746d;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.45;
}

.expert-capacity-page .expert-capacity-header__actions {
  display: flex;
  align-items: center;
  align-self: center;
  gap: 8px;
  margin-left: auto;
  margin-right: 32px;
  flex: 0 0 auto;
}

.expert-capacity-page .expert-capacity-health {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 35px;
  padding: 0 12px;
  border: 1px solid #dfe4dc;
  border-radius: 9px;
  color: #697269;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-page .expert-capacity-health i {
  color: #6f8766;
  font-size: 12px;
  box-shadow: 0 0 0 4px #eef4eb;
  border-radius: 50%;
}

.expert-capacity-page .expert-capacity-create {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 0;
  min-height: 42px;
  padding: 0 19px;
  border: 1px solid #c54b2a;
  color: #fff;
  background: var(--expert-orange);
  box-shadow: 0 8px 18px rgba(157, 57, 29, 0.14);
  cursor: pointer;
  transition: transform 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;
}

.expert-capacity-page .expert-capacity-create:hover {
  background: #c94b2b;
  box-shadow: 0 11px 23px rgba(157, 57, 29, 0.2);
  transform: translateY(-1px);
}

.expert-portfolio-overview {
  display: grid;
  grid-template-columns: 1.28fr repeat(5, minmax(135px, 1fr));
  overflow: hidden;
  border: 1px solid var(--expert-line);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 28px rgba(31, 38, 31, 0.045);
}

.expert-portfolio-overview__intro {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  min-height: 126px;
  padding: 23px 25px;
  color: #fff;
  background: #30362f;
}

.expert-portfolio-overview__intro > div {
  display: grid;
  gap: 5px;
}

.expert-portfolio-overview__intro small {
  color: #cbd2c8;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
}

.expert-portfolio-overview__intro strong {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.expert-portfolio-overview__intro p {
  margin: 0;
  color: #bdc5ba;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.55;
}

.expert-portfolio-overview__intro > span {
  display: grid;
  flex: 0 0 46px;
  width: 46px;
  height: 46px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 13px;
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
  font-size: 18px;
}

.expert-portfolio-metric {
  --metric-color: #657a5e;
  --metric-soft: #eef3eb;
  position: relative;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  min-width: 0;
  min-height: 126px;
  padding: 20px 17px;
  border: 0;
  border-left: 1px solid var(--expert-line-soft);
  color: inherit;
  background: #fff;
  text-align: left;
}

button.expert-portfolio-metric,
label.expert-portfolio-metric {
  cursor: pointer;
}

.expert-portfolio-metric::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  background: var(--metric-color);
  content: "";
  opacity: 0;
  transform: scaleX(0.35);
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.expert-portfolio-metric:hover::after,
.expert-portfolio-metric.is-active::after {
  opacity: 0.85;
  transform: scaleX(1);
}

.expert-portfolio-metric.is-active {
  background: #fbfcfa;
}

.expert-portfolio-metric--assignable {
  --metric-color: #657c5e;
  --metric-soft: #eef3eb;
}

.expert-portfolio-metric--attention {
  --metric-color: #b87828;
  --metric-soft: #fbf2e5;
}

.expert-portfolio-metric--immediate {
  --metric-color: #ba663d;
  --metric-soft: #fff0e9;
}

.expert-portfolio-metric--project {
  --metric-color: #4f756a;
  --metric-soft: #ecf3f1;
}

.expert-portfolio-metric--rating {
  --metric-color: #80704d;
  --metric-soft: #f5f1e7;
}

.expert-portfolio-metric > input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.expert-portfolio-metric:has(input:focus-visible) {
  outline: 2px solid #6d8765;
  outline-offset: -3px;
}

.expert-portfolio-metric__icon {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  color: var(--metric-color);
  background: var(--metric-soft);
}

.expert-portfolio-metric > div {
  display: grid;
  min-width: 0;
  gap: 1px;
}

.expert-portfolio-metric small {
  color: #727872;
}

.expert-portfolio-metric strong {
  color: #292d29;
  letter-spacing: -0.035em;
}

.expert-portfolio-metric em {
  overflow: hidden;
  color: #989d97;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.expert-portfolio-metric > i {
  position: absolute;
  right: 13px;
  top: 14px;
  color: #b7bcb6;
  font-size: 12px;
  opacity: 0;
  transform: translateX(-3px);
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.expert-portfolio-metric:hover > i,
.expert-portfolio-metric.is-active > i {
  opacity: 1;
  transform: translateX(0);
}

.expert-capacity-page .expert-capacity-shell,
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-shell {
  border: 0 !important;
  background: transparent !important;
}

.expert-capacity-page .expert-capacity-main,
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-main {
  overflow: visible;
  border: 1px solid var(--expert-line) !important;
  border-radius: 16px !important;
  background: #fff !important;
  box-shadow: 0 10px 32px rgba(31, 38, 31, 0.05) !important;
}

.expert-capacity-page .expert-capacity-toolbar {
  position: relative;
  z-index: 35;
  display: grid;
  min-height: 0;
  padding: 0;
  overflow: visible;
  border: 0 !important;
  border-radius: 16px 16px 0 0;
  background: #fff;
  box-shadow: none !important;
}

.expert-capacity-toolbar__heading {
  display: grid;
  min-width: 245px;
  gap: 3px;
}

.expert-capacity-toolbar__heading > p {
  margin: 0;
  color: var(--expert-orange);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.15em;
}

.expert-capacity-toolbar__heading > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.expert-capacity-toolbar__heading h2 {
  margin: 0;
  color: #282c28;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.expert-capacity-toolbar__heading > div > span {
  display: inline-grid;
  min-width: 28px;
  height: 22px;
  padding: 0 8px;
  place-items: center;
  border-radius: 999px;
  color: #687068;
  background: #eff1ec;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-toolbar__heading > small {
  color: #919690;
  font-size: 12px;
  font-weight: 600;
}

.expert-capacity-page .expert-capacity-search {
  border: 1px solid #dcded8;
  background: #fbfbfa;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.expert-capacity-page .expert-capacity-search:focus-within {
  border-color: #819283;
  background: #fff;
}

.expert-capacity-page .expert-capacity-search > i {
  position: absolute;
  left: 14px;
  z-index: 1;
  color: #818881;
  font-size: 12px;
  pointer-events: none;
}

.expert-capacity-page .expert-capacity-search input {
  width: 100%;
  height: 100%;
  padding: 0 38px;
  color: #414641;
  box-shadow: none;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-page .expert-capacity-search button {
  position: absolute;
  right: 8px;
  display: grid;
  width: 26px;
  height: 26px;
  padding: 0;
  place-items: center;
  border: 0;
  color: #818781;
  background: #eff0ed;
  cursor: pointer;
}

.expert-capacity-page .expert-capacity-sort {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 42px;
  min-width: 0;
  margin: 0;
  border: 1px solid #dcded8;
  border-radius: 9px;
  background: #fbfbfa;
}

.expert-capacity-page .expert-capacity-sort > i {
  position: absolute;
  left: 13px;
  color: #7d857d;
  font-size: 12px;
  pointer-events: none;
}

.expert-capacity-page .expert-capacity-sort::after {
  position: absolute;
  right: 12px;
  color: #7c837c;
  content: "⌄";
  font-size: 12px;
  font-weight: 700;
  pointer-events: none;
  transform: translateY(-1px);
}

.expert-capacity-page .expert-capacity-sort select {
  width: 100%;
  height: 100%;
  padding: 0 28px 0 34px;
  border: 0;
  outline: 0;
  color: #4b514b;
  background: transparent;
  box-shadow: none;
  cursor: pointer;
  appearance: none;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-toolbar__bottom {
  border-top: 1px solid #f0f1ed;
  border-bottom: 1px solid var(--expert-line);
  background: #fafbf8;
}

.expert-status-tabs {
  display: flex;
  align-items: center;
  gap: 5px;
}

.expert-status-tabs button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid transparent;
  color: #777e77;
  background: transparent;
  cursor: pointer;
  transition: color 0.18s ease, border-color 0.18s ease, background 0.18s ease;
}

.expert-status-tabs button:hover {
  color: #3f473f;
  background: #f0f2ed;
}

.expert-status-tabs button.is-active {
  border-color: #d7dfd3;
  color: #354334;
  background: #edf2ea;
}

.expert-status-tabs button em {
  display: inline-grid;
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  place-items: center;
  color: #7c827b;
  background: #e9ebe6;
  font-style: normal;
}

.expert-status-tabs button.is-active em {
  color: #fff;
  background: #60745b;
}

.expert-capacity-page .expert-compact-filters {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.expert-capacity-page .expert-compact-filter,
.expert-capacity-page .expert-compact-filter--field {
  width: auto;
  min-width: 118px;
  height: 36px;
  flex: 0 0 auto;
  border: 1px solid #dce0da;
  border-radius: 8px;
  background: #fff;
  box-shadow: none;
}

.expert-capacity-page .expert-compact-filter--field {
  min-width: 142px;
}

.expert-capacity-page .expert-compact-filter.is-open {
  border-color: #718b79;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(86, 112, 95, 0.1);
}

.expert-capacity-page .expert-compact-filter > i {
  left: 10px;
  color: #79837b;
  font-size: 12px;
}

.expert-capacity-page .expert-compact-filter__trigger {
  padding: 0 9px 0 28px;
  border: 0 !important;
  color: #505751;
  background: transparent;
  box-shadow: none !important;
}

.expert-capacity-page .expert-compact-filter__menu {
  top: calc(100% + 7px);
  min-width: 164px;
  padding: 6px;
  border: 1px solid #d8ddd7;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 32px rgba(35, 49, 42, 0.16);
}

.expert-capacity-page .expert-compact-filter__menu button {
  min-height: 34px;
}

.expert-capacity-page .expert-compact-toggle {
  min-width: 86px;
  height: 36px;
  border: 1px solid #dce0da;
  border-radius: 8px;
  color: #626a63;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-page .expert-compact-toggle.is-active {
  border-color: #dbb8a7;
  color: #bb5737;
  background: #fff2ec;
}

.expert-capacity-page .expert-compact-filter-reset {
  width: 36px;
  height: 36px;
  border: 1px solid #dce0da;
  color: #69736b;
  background: #fff;
}

.expert-capacity-page .expert-capacity-table-wrap {
  z-index: 1;
}

.expert-capacity-page .expert-capacity-table {
  width: 100%;
  min-width: 1080px;
  table-layout: fixed;
  border-collapse: collapse;
}

.expert-capacity-page .expert-capacity-table th {
  height: 43px;
  padding: 0 14px;
  border: 0;
  border-bottom: 1px solid #e7eae4;
  color: #818780;
  background: #f7f8f6;
  box-shadow: none;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.025em;
  text-align: left;
}

.expert-capacity-page .expert-capacity-table th:first-child,
.expert-capacity-page .expert-capacity-table td:first-child {
  width: 30%;
  padding-left: 24px;
}

.expert-capacity-page .expert-capacity-table th:nth-child(2) {
  width: 12%;
}

.expert-capacity-page .expert-capacity-table th:nth-child(3) {
  width: 14%;
}

.expert-capacity-page .expert-capacity-table th:nth-child(4) {
  width: 13%;
}

.expert-capacity-page .expert-capacity-table th:nth-child(5) {
  width: 9%;
}

.expert-capacity-page .expert-capacity-table th:nth-child(6) {
  width: 11%;
}

.expert-capacity-page .expert-capacity-table th:nth-child(7) {
  width: 11%;
}

.expert-capacity-page .expert-capacity-row {
  height: 124px;
  min-height: 124px;
  background: #fff;
  box-shadow: none;
  transition: background 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
}

.expert-capacity-page .expert-capacity-row:hover {
  background: #fcfcf9;
  box-shadow: inset 3px 0 0 var(--expert-orange);
}

.expert-capacity-page .expert-capacity-row.is-expanded {
  background: #fafbf8;
  box-shadow: inset 3px 0 0 #60765a;
}

.expert-capacity-page .expert-capacity-row.is-inactive {
  opacity: 0.68;
}

.expert-capacity-page .expert-capacity-row td {
  height: 124px;
  padding: 15px 14px;
  border: 0;
  border-bottom: 1px solid #e7eae4;
  vertical-align: middle;
}

.expert-capacity-page .expert-capacity-identity {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 13px;
}

.expert-capacity-page .expert-capacity-avatar {
  display: grid;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  place-items: center;
  border: 1px solid #dce3d9;
  border-radius: 13px;
  color: #60725c;
  background: #f0f4ee;
  font-size: 14px;
  font-weight: 700;
}

.expert-capacity-page .expert-capacity-identity > div {
  display: grid;
  min-width: 0;
  gap: 5px;
}

.expert-capacity-page .expert-capacity-identity > div > strong {
  display: flex;
  align-items: center;
  gap: 7px;
  overflow: hidden;
  color: #2d312d;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.015em;
  white-space: nowrap;
}

.expert-active-badge {
  display: inline-flex;
  min-height: 20px;
  padding: 0 7px;
  align-items: center;
  border: 1px solid #d9e1d5;
  border-radius: 999px;
  color: #5f7658;
  background: #f2f6f0;
  font-size: 12px;
  font-weight: 700;
}

.expert-active-badge.is-inactive {
  border-color: #e1e2df;
  color: #858a84;
  background: #f4f5f3;
}

.expert-capacity-page .expert-capacity-identity p {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0;
}

.expert-capacity-page .expert-capacity-identity p span {
  display: inline-flex;
  min-height: 20px;
  padding: 0 7px;
  align-items: center;
  border-radius: 6px;
  color: #687168;
  background: #f0f2ed;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-email {
  overflow: hidden;
  max-width: 260px;
  color: #9da29c;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.expert-capacity-page .expert-capacity-meter {
  display: grid;
  width: min(100%, 112px);
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 4px 7px;
}

.expert-capacity-page .expert-capacity-meter strong {
  color: #343934;
  font-size: 14px;
  font-weight: 700;
}

.expert-capacity-page .expert-capacity-meter > div {
  height: 5px;
  overflow: hidden;
  border-radius: 999px;
  background: #e7eae4;
}

.expert-capacity-page .expert-capacity-meter > div i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #6b8065;
}

.expert-capacity-page .expert-capacity-meter.is-medium > div i {
  background: #b88438;
}

.expert-capacity-page .expert-capacity-meter.is-low > div i {
  background: #b86048;
}

.expert-capacity-page .expert-capacity-meter small {
  grid-column: 1/-1;
  color: #90958f;
  font-size: 12px;
  font-weight: 700;
}

.expert-assignment-load {
  display: grid;
  grid-template-columns: repeat(2, minmax(44px, 1fr));
  overflow: hidden;
  width: min(100%, 145px);
  border: 1px solid #e3e6e0;
  border-radius: 9px;
  background: #fafbf9;
}

.expert-assignment-load > span {
  display: grid;
  min-height: 48px;
  padding: 7px 9px;
  align-content: center;
  gap: 1px;
}

.expert-assignment-load > span + span {
  border-left: 1px solid #e3e6e0;
}

.expert-assignment-load small {
  color: #969b95;
  font-size: 12px;
  font-weight: 700;
}

.expert-assignment-load strong {
  color: #3d423d;
  font-size: 12px;
  font-weight: 700;
}

.expert-assignment-load > em {
  grid-column: 1/-1;
  padding: 5px 9px;
  border-top: 1px solid #e3e6e0;
  color: #989d97;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.expert-capacity-page .expert-capacity-progress {
  display: grid;
  width: min(100%, 115px);
  gap: 6px;
}

.expert-capacity-page .expert-capacity-progress strong {
  color: #363b36;
  font-size: 13px;
  font-weight: 700;
}

.expert-capacity-page .expert-capacity-progress > div {
  height: 5px;
  overflow: hidden;
  border-radius: 999px;
  background: #e7eae4;
}

.expert-capacity-page .expert-capacity-progress > div i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #607761;
}

.expert-capacity-page .expert-capacity-rating {
  display: grid;
  gap: 3px;
}

.expert-capacity-page .expert-capacity-rating strong {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #3e433e;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-page .expert-capacity-rating strong i {
  color: #c79a40;
  font-size: 12px;
}

.expert-capacity-page .expert-capacity-rating small {
  color: #9a9f99;
  font-size: 12px;
  font-weight: 600;
}

.expert-capacity-page .expert-capacity-row time {
  display: inline-flex;
  min-height: 29px;
  padding: 0 9px;
  align-items: center;
  border: 1px solid #e0e3dd;
  border-radius: 8px;
  color: #666d66;
  background: #fafbf9;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.expert-capacity-page .expert-capacity-row time.is-immediate {
  border-color: #ead4c8;
  color: #bd5738;
  background: #fff3ed;
}

.expert-capacity-page .expert-capacity-actions {
  display: grid;
  grid-template-columns: minmax(68px, 1fr) 32px 32px;
  gap: 6px;
}

.expert-capacity-page .expert-capacity-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: 34px;
  padding: 0 9px;
  border: 1px solid #dce0da;
  color: #606861;
  background: #fff;
  cursor: pointer;
  transition: transform 0.18s ease, border-color 0.18s ease, color 0.18s ease, background 0.18s ease;
}

.expert-capacity-page .expert-capacity-actions button:first-child {
  border-color: #30342f;
  color: #fff;
  background: #30342f;
}

.expert-capacity-page .expert-capacity-actions button:hover {
  transform: translateY(-1px);
}

.expert-capacity-page .expert-capacity-actions button:first-child:hover {
  background: #202320;
}

.expert-capacity-page .expert-capacity-expanded td {
  padding: 0;
  border-bottom: 1px solid #dfe3dc;
  background: #f5f7f3;
}

.expert-capacity-page .expert-assignment-panel {
  display: grid;
  grid-template-columns: minmax(0, 1.8fr) minmax(170px, 0.75fr) minmax(150px, 0.7fr);
  gap: 12px;
  padding: 16px 24px 22px;
  background: transparent;
}

.expert-capacity-page .expert-assignment-panel > section {
  min-height: 210px;
  padding: 19px 20px;
  border: 1px solid #dfe3dc;
  border-radius: 12px;
  background: #fff;
}

.expert-capacity-page .expert-assignment-task header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.expert-capacity-page .expert-assignment-task header strong {
  color: #343934;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-page .expert-assignment-task header span {
  padding: 5px 8px;
  border-radius: 999px;
  color: #5d7457;
  background: #edf3ea;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-page .expert-assignment-task article {
  padding: 14px;
  border: 1px solid #e5e8e2;
  border-radius: 9px;
  background: #fafbf9;
}

.expert-capacity-page .expert-assignment-task h3 {
  margin: 0 0 12px;
  color: #333833;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-page .expert-assignment-task dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
}

.expert-capacity-page .expert-assignment-task dl > div {
  display: grid;
  gap: 2px;
}

.expert-capacity-page .expert-assignment-task dt {
  color: #999e98;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-page .expert-assignment-task dd {
  margin: 0;
  color: #464b46;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-page .expert-assignment-score {
  display: grid;
  align-content: center;
  justify-items: center;
  text-align: center;
}

.expert-capacity-page .expert-assignment-score > span {
  color: #8b908a;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-page .expert-assignment-score > strong {
  color: #52684f;
  font-size: 34px;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.expert-capacity-page .expert-assignment-score > strong em {
  font-size: 12px;
  font-style: normal;
}

.expert-capacity-page .expert-assignment-score ul {
  display: grid;
  gap: 6px;
  margin: 12px 0 0;
  padding: 0;
  color: #747b73;
  list-style: none;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-page .expert-assignment-score li {
  display: flex;
  align-items: center;
  gap: 6px;
}

.expert-capacity-page .expert-assignment-score li i {
  color: #6a8064;
}

.expert-capacity-page .expert-assignment-actions {
  display: grid;
  align-content: center;
  gap: 8px;
}

.expert-capacity-page .expert-assignment-actions button {
  min-height: 38px;
  border: 1px solid #dce0da;
  color: #5b645c;
  background: #fff;
  cursor: pointer;
}

.expert-capacity-page .expert-assignment-actions button:first-child {
  border-color: #30342f;
  color: #fff;
  background: #30342f;
}

.expert-capacity-page .expert-assignment-panel > footer {
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  gap: 7px;
  min-height: 34px;
  padding: 0 4px;
}

.expert-capacity-page .expert-assignment-panel > footer strong {
  margin-right: 5px;
  color: #777e77;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-page .expert-assignment-panel > footer span {
  padding: 5px 8px;
  border-radius: 6px;
  color: #677067;
  background: #e9ece6;
  font-size: 12px;
  font-weight: 700;
}

.expert-capacity-page .expert-capacity-empty {
  display: grid;
  min-height: 320px;
  padding: 50px 24px;
  place-items: center;
  align-content: center;
  gap: 8px;
  color: #898f88;
  background: #fff;
  text-align: center;
}

.expert-capacity-page .expert-capacity-empty > i {
  display: grid;
  width: 56px;
  height: 56px;
  margin-bottom: 4px;
  place-items: center;
  border: 1px solid #dfe3dc;
  border-radius: 16px;
  color: #6c7a69;
  background: #f2f5f0;
  font-size: 19px;
}

.expert-capacity-page .expert-capacity-empty strong {
  color: #393e39;
  font-size: 13px;
  font-weight: 700;
}

.expert-capacity-page .expert-capacity-empty p {
  max-width: 430px;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.55;
}

.expert-capacity-page .expert-capacity-empty button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 40px;
  margin-top: 7px;
  padding: 0 16px;
  border: 1px solid #d7ddd4;
  color: #4f5a4d;
  background: #fff;
  cursor: pointer;
}

.expert-capacity-page .expert-capacity-empty button i {
  display: inline-block;
  width: auto;
  height: auto;
  margin: 0;
  border: 0;
  border-radius: 0;
  color: #62745f;
  background: transparent;
  font-size: 12px;
}

.expert-capacity-page .expert-capacity-empty button:hover {
  border-color: #b7c3b3;
  background: #f5f8f3;
}

.expert-capacity-page .expert-capacity-footer,
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-footer {
  border: 0 !important;
  color: #858b84;
  background: #fafbf8;
}

.expert-capacity-page .expert-capacity-footer nav {
  display: flex;
  grid-column: 2;
  gap: 5px;
}

.expert-capacity-page .expert-capacity-footer__page-size {
  grid-column: 3;
  justify-self: end;
  white-space: nowrap;
}

.expert-capacity-page .expert-capacity-footer button {
  display: grid;
  width: 30px;
  height: 30px;
  padding: 0;
  place-items: center;
  border: 1px solid #dfe3dc;
  color: #747b74;
  background: #fff;
}

.expert-capacity-page .expert-capacity-footer button.is-active {
  border-color: #d85a36;
  color: #d25231;
  background: #fff7f3;
}

.expert-capacity-page .expert-capacity-footer button:disabled {
  color: #c7cbc5;
  background: #f4f5f2;
}

/* Expert invite dialog refinement. */
.expert-capacity-page ~ .ops-modal-backdrop .ops-modal {
  overflow: hidden;
  border: 1px solid #dce1da;
  border-radius: 16px;
  box-shadow: 0 28px 80px rgba(29, 34, 28, 0.24);
}

.expert-capacity-page ~ .ops-modal-backdrop .ops-modal__header {
  border-bottom: 1px solid #e6e9e3;
  background: #fafbf8;
}

.expert-capacity-page ~ .ops-modal-backdrop .ops-modal__header p {
  color: var(--expert-orange);
}

.expert-capacity-page ~ .ops-modal-backdrop .ops-modal__footer {
  border-top: 1px solid #e8ebe5;
  background: #fafbf8;
}

.expert-capacity-page ~ .ops-modal-backdrop .ops-modal-submit {
  border-color: #c54b2a;
  background: var(--expert-orange);
}

@media (max-width: 1300px) {
  .expert-portfolio-overview {
    grid-template-columns: 1.25fr repeat(3, 1fr);
  }
  .expert-portfolio-overview__intro {
    grid-row: span 2;
  }
  .expert-portfolio-metric {
    min-height: 92px;
  }
  .expert-capacity-page .expert-compact-filters {
    justify-content: flex-start;
    width: 100%;
  }
}
@media (max-width: 1020px) {
  .expert-capacity-page .expert-capacity-mobile {
    background: #f6f8f4;
  }
  .expert-capacity-page .expert-capacity-mobile > article {
    display: grid;
    gap: 14px;
    padding: 18px;
    border: 1px solid #dfe3dc;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 4px 16px rgba(31, 38, 31, 0.035);
  }
  .expert-capacity-page .expert-capacity-mobile article > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .expert-capacity-page .expert-capacity-mobile article > header > button {
    display: grid;
    width: 34px;
    height: 34px;
    padding: 0;
    place-items: center;
    border: 1px solid #dce0da;
    color: #616961;
    background: #fff;
  }
  .expert-capacity-page .expert-capacity-mobile article dl {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    margin: 0;
    overflow: hidden;
    border: 1px solid #e4e7e1;
    border-radius: 9px;
  }
  .expert-capacity-page .expert-capacity-mobile article dl > div {
    display: grid;
    min-height: 56px;
    padding: 9px 11px;
    align-content: center;
    gap: 3px;
    border-right: 1px solid #e4e7e1;
    background: #fff;
  }
  .expert-capacity-page .expert-capacity-mobile article dl > div:last-child {
    border-right: 0;
  }
  .expert-capacity-page .expert-capacity-mobile dt {
    color: #999e98;
    font-size: 12px;
    font-weight: 700;
  }
  .expert-capacity-page .expert-capacity-mobile dd {
    margin: 0;
    color: #3e433e;
    font-size: 12px;
    font-weight: 700;
  }
  .expert-capacity-page .expert-capacity-mobile__assign {
    min-height: 38px;
    border: 1px solid #30342f;
    color: #fff;
    background: #30342f;
    cursor: pointer;
  }
}
@media (max-width: 639px) {
  .expert-capacity-page .expert-capacity-header__actions {
    width: 100%;
    align-self: stretch;
    margin-left: 0;
    margin-right: 0;
  }
  .expert-capacity-page .expert-capacity-create {
    width: 100%;
  }
}
/* Expert directory frame and sort menu ----------------------------------- */
.expert-capacity-page .expert-capacity-shell,
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-shell {
  border: 1px solid var(--expert-line) !important;
  background: #fff !important;
}

.expert-capacity-page .expert-capacity-main,
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-main {
  overflow: visible !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.expert-capacity-page .expert-capacity-toolbar,
.expert-capacity-page .expert-capacity-toolbar__top,
.expert-capacity-page .expert-capacity-toolbar__bottom,
.expert-capacity-page .expert-capacity-table-wrap,
.expert-capacity-page .expert-capacity-footer {
  border-radius: 0 !important;
  box-shadow: none !important;
}

.expert-capacity-page .expert-capacity-toolbar__top {
  border: 0 !important;
  border-bottom: 1px solid #eef0eb !important;
}

.expert-capacity-page .expert-capacity-toolbar__bottom {
  border: 0 !important;
  border-bottom: 1px solid var(--expert-line) !important;
}

.expert-capacity-page .expert-capacity-table {
  border: 0 !important;
  border-spacing: 0;
}

.expert-capacity-page .expert-capacity-row {
  box-shadow: none !important;
}

.expert-capacity-page .expert-capacity-table tbody > tr:last-child > td {
  border-bottom: 0 !important;
}

.expert-capacity-page .expert-capacity-footer {
  border: 0 !important;
  border-top: 1px solid #e5e8e2 !important;
}

.expert-capacity-page .expert-capacity-sort {
  z-index: 45;
  overflow: visible !important;
}

.expert-capacity-page .expert-capacity-sort.is-open {
  border-color: #718b79 !important;
  background: #fff !important;
  box-shadow: 0 0 0 3px rgba(86, 112, 95, 0.1) !important;
}

.expert-capacity-page .expert-capacity-sort::after {
  display: none;
}

.expert-capacity-page .expert-capacity-sort__trigger {
  display: flex;
  width: 100%;
  height: 100%;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 12px 0 34px;
  border: 0 !important;
  outline: 0;
  color: #454c46 !important;
  background: transparent !important;
  box-shadow: none !important;
  cursor: pointer;
  text-align: left;
}

.expert-capacity-page .expert-capacity-sort__trigger > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.expert-capacity-page .expert-capacity-sort__caret {
  flex: 0 0 auto;
  color: #7c837c;
  font-size: 12px;
  transition: transform 150ms ease;
}

.expert-capacity-page .expert-capacity-sort.is-open .expert-capacity-sort__caret {
  color: #4b6f5d;
  transform: rotate(180deg);
}

.expert-capacity-page .expert-capacity-sort__menu {
  position: absolute;
  top: calc(100% + 7px);
  right: -1px;
  z-index: 100;
  display: grid;
  width: max(100%, 184px);
  gap: 2px;
  padding: 6px;
  border: 1px solid #d8ddd7;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 32px rgba(35, 49, 42, 0.16);
}

.expert-capacity-page .expert-capacity-sort__menu button {
  display: grid;
  width: 100%;
  min-height: 34px;
  grid-template-columns: 16px minmax(0, 1fr);
  align-items: center;
  gap: 7px;
  padding: 0 9px;
  border: 0 !important;
  outline: 0;
  color: #4e5651 !important;
  background: transparent !important;
  box-shadow: none !important;
  cursor: pointer;
  text-align: left;
}

.expert-capacity-page .expert-capacity-sort__menu button i {
  color: transparent;
  font-size: 12px;
}

.expert-capacity-page .expert-capacity-sort__menu button:hover,
.expert-capacity-page .expert-capacity-sort__menu button:focus-visible {
  color: #315846 !important;
  background: #eef4f0 !important;
}

.expert-capacity-page .expert-capacity-sort__menu button.is-selected {
  color: #244d3a !important;
  background: #e7f0ea !important;
}

.expert-capacity-page .expert-capacity-sort__menu button.is-selected i {
  color: #32654d;
}

/* Keep the expert directory clear of the sidebar edge. */
.expert-capacity-page .expert-capacity-content.ops-shell {
  box-sizing: border-box;
}

/* Brighter expert management surfaces */
.expert-capacity-page .expert-portfolio-overview,
.expert-capacity-page .expert-portfolio-metric,
.expert-capacity-page .expert-capacity-shell,
.expert-capacity-page .expert-capacity-main,
.expert-capacity-page .expert-capacity-empty {
  border-color: #e3e7e1 !important;
  background: #fff !important;
}

.expert-capacity-page .expert-portfolio-overview__intro {
  color: var(--expert-ink);
  background: #fff7f2 !important;
  box-shadow: inset 4px 0 0 var(--expert-orange);
}

.expert-capacity-page .expert-portfolio-overview__intro small {
  color: var(--expert-orange);
}

.expert-capacity-page .expert-portfolio-overview__intro strong {
  color: var(--expert-ink);
}

.expert-capacity-page .expert-portfolio-overview__intro p {
  color: var(--expert-muted);
}

.expert-capacity-page .expert-portfolio-overview__intro > span {
  border-color: #f1d9cd;
  color: var(--expert-orange);
  background: #fff;
}

@media (max-width: 720px) {
  .expert-capacity-page .ops-shell,
  .expert-capacity-page .expert-capacity-header__inner,
  .expert-capacity-page .expert-capacity-content.ops-shell {
    width: min(100% - 24px, 1480px);
  }
  .expert-capacity-page .expert-capacity-header__actions {
    align-items: stretch;
    flex-direction: column;
  }
  .expert-capacity-page .expert-capacity-create {
    width: 100%;
  }
  .expert-portfolio-overview {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .expert-portfolio-overview__intro {
    grid-column: 1/-1;
    grid-row: auto;
    min-height: 110px;
  }
  .expert-portfolio-metric {
    min-height: 92px;
    padding: 15px;
  }
  .expert-status-tabs {
    width: 100%;
    overflow-x: auto;
  }
  .expert-capacity-page .expert-compact-filters {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .expert-capacity-page .expert-compact-filter,
  .expert-capacity-page .expert-compact-filter--field,
  .expert-capacity-page .expert-compact-toggle {
    width: 100%;
    min-width: 0;
  }
  .expert-capacity-page .expert-compact-filter-reset {
    width: 100%;
  }
  .expert-capacity-page .expert-capacity-mobile article dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .expert-capacity-page .expert-capacity-mobile article dl > div:nth-child(2) {
    border-right: 0;
  }
  .expert-capacity-page .expert-capacity-mobile article dl > div:nth-child(-n+2) {
    border-bottom: 1px solid #e4e7e1;
  }
  .expert-capacity-page .expert-capacity-footer nav {
    justify-self: end;
  }
  .expert-capacity-page .expert-capacity-footer__page-size {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .expert-capacity-page .expert-capacity-create,
  .expert-portfolio-metric::after,
  .expert-portfolio-metric > i,
  .expert-capacity-page .expert-capacity-row,
  .expert-capacity-page .expert-capacity-actions button {
    transition: none;
  }
}
/* Keep the expert directory toolbar continuous across the full ledger width. */
.expert-capacity-page .expert-capacity-main {
  display: grid !important;
  grid-template-columns: minmax(0, 1fr) !important;
  width: 100% !important;
  min-width: 0 !important;
  max-width: none !important;
}

.expert-capacity-page .expert-capacity-toolbar,
.expert-capacity-page .expert-capacity-toolbar__top,
.expert-capacity-page .expert-capacity-toolbar__bottom,
.expert-capacity-page .expert-capacity-table-wrap,
.expert-capacity-page .expert-capacity-mobile,
.expert-capacity-page .expert-capacity-empty,
.expert-capacity-page .expert-capacity-footer {
  grid-column: 1/-1 !important;
  width: 100% !important;
  min-width: 0 !important;
  max-width: none !important;
  align-self: stretch !important;
  justify-self: stretch !important;
  box-sizing: border-box;
}

.expert-capacity-page .expert-capacity-toolbar__heading {
  width: 100% !important;
  min-width: 0 !important;
}

.expert-capacity-page .expert-capacity-toolbar__controls .expert-capacity-search,
.expert-capacity-page .expert-capacity-toolbar__controls .expert-capacity-sort {
  width: 100% !important;
  max-width: none !important;
  min-width: 0 !important;
}

.expert-capacity-page .expert-capacity-toolbar__bottom {
  background: #fafbf8 !important;
}

.expert-capacity-page .expert-status-tabs {
  width: 100% !important;
  min-width: 0 !important;
}

.expert-capacity-page .expert-compact-filters {
  display: grid !important;
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  width: 100% !important;
  min-width: 0 !important;
}

.expert-capacity-page .expert-compact-filter,
.expert-capacity-page .expert-compact-filter--field,
.expert-capacity-page .expert-compact-toggle {
  width: 100% !important;
  min-width: 0 !important;
}

@media (max-width: 920px) {
  .expert-capacity-page .expert-compact-filters {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}
/* Unified operations header ------------------------------------------------ */
.expert-capacity-page .expert-capacity-header__inner {
  margin-inline: auto;
  box-sizing: border-box;
}

.expert-capacity-page .expert-capacity-header__actions {
  align-self: center;
  margin-left: auto;
  margin-right: 0;
}

@media (max-width: 639px) {
  .expert-capacity-page .expert-capacity-header__actions {
    width: 100%;
    align-self: stretch;
    margin-left: 0;
  }
  .expert-capacity-page .expert-capacity-create {
    width: 100%;
  }
}
/* 11: workspace information hierarchy and shared component roles. */
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-ledger {
  border-radius: 12px;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-compact-filter, :host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-sort {
  position: relative;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-compact-filter > i, :host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-sort > i {
  display: none;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-compact-filter__trigger, :host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-sort__trigger {
  position: static;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px !important;
  min-height: 44px;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-compact-filter__trigger > span {
  min-width: 0;
  white-space: normal;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-compact-filter__caret, :host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-sort__caret {
  position: static;
  flex: none;
  margin-left: auto;
  transform: none;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-compact-filters {
  gap: 8px;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-empty {
  min-height: 0;
  padding: 24px 16px;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-empty > i {
  width: 40px;
  height: 40px;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-sort {
  height: auto;
  min-height: 44px;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-table {
  min-width: 960px;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-table th:first-child {
  width: 24%;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-table th:nth-child(4) {
  width: 12%;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-table th:nth-child(5) {
  width: 8%;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-table th:nth-child(6) {
  width: 12%;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-table th:nth-child(7) {
  width: 18%;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-actions {
  flex-wrap: wrap;
  gap: 8px;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-actions > button:first-child {
  flex: 1 1 100%;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-identity strong,
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-identity p,
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-identity small {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  overflow-wrap: anywhere;
}
@media (min-width: 1024px) {
  :host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-toolbar__heading {
    width: auto !important;
    flex: 0 1 240px;
  }
  :host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-toolbar__controls {
    flex: 1 1 360px;
  }
  :host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-toolbar__controls .expert-capacity-sort {
    width: auto !important;
    flex: 0 1 156px;
  }
  :host-context(.reviewops-shell) .expert-capacity-page .expert-status-tabs {
    width: auto !important;
    flex: 0 1 auto;
  }
  :host-context(.reviewops-shell) .expert-capacity-page .expert-compact-filters {
    flex: 1 1 540px;
    grid-template-columns: repeat(3, minmax(0, 1fr)) auto auto !important;
  }
}

/* 19G LIST-RADIUS-001: round the painted edges without clipping filter menus. */
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-shell {
  border-color: var(--ro-line) !important;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-main {
  border-radius: 11px !important;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-toolbar,
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-toolbar__top {
  border-radius: 11px 11px 0 0 !important;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-toolbar__top,
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-toolbar__bottom {
  border-bottom-color: var(--ro-line) !important;
}
:host-context(.reviewops-shell) .expert-capacity-page .expert-capacity-footer {
  border-top: 1px solid var(--ro-line) !important;
  border-radius: 0 0 11px 11px !important;
}`],
})
export class PageExpertsComponent implements OnInit {
    public keyword: string = '';
    public field: string = '전체';
    public reviewType: string = '전체 (QA/KG)';
    public statusFilter: string = '전체';
    public capacityFilter: string = '전체';
    public openCompactFilter: string = '';
    public immediateOnly: boolean = false;
    public sortMode: string = '가용량 높은 순';
    public currentPage: number = 1;
    public readonly pageSize: number = 10;
    public expandedId: string | null = null;
    public showInviteModal: boolean = false;
    public invite: any = { name: '', email: '', field: '동북아 역사', reviewType: 'QA·KG' };
    public userQuery: string = '';
    public selectedUserId: string = '';
    public registeredUsers: any[] = [];
    public experts: any[] = [];
    private readonly expertStorageKey: string = 'review-experts-v1';

    constructor(@Inject( Service) public service: Service) { }

    private readStoredExperts() {
        if (typeof window === 'undefined') return [];
        try {
            const rows = JSON.parse(window.localStorage.getItem(this.expertStorageKey) || '[]');
            return Array.isArray(rows) ? rows : [];
        } catch (error) {
            return [];
        }
    }

    private loadStoredExperts() {
        const rows = this.readStoredExperts();
        if (rows.length) this.experts = rows;
    }

    private persistExperts() {
        if (typeof window === 'undefined') return;
        window.localStorage.setItem(this.expertStorageKey, JSON.stringify(this.experts));
    }

    private nextExpertId() {
        const maxId = this.experts.reduce((max: number, expert: any) => {
            const match = String(expert.id || '').match(/^EX-(\d+)$/);
            return match ? Math.max(max, Number(match[1])) : max;
        }, 0);
        return 'EX-' + String(maxId + 1).padStart(3, '0');
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role('admin', '/access');
        await this.loadRegisteredUsers();
        this.loadStoredExperts();
        await this.service.render();
    }

    private async loadRegisteredUsers() {
        const { code, data } = await wiz.call('registered_users');
        this.registeredUsers = code === 200 && Array.isArray(data) ? data : [];
    }

    public filteredExperts() {
        const query = this.keyword.trim().toLowerCase();
        const rows = this.experts.filter((expert: any) => {
            const expertReviewType = this.reviewTypeLabel(expert);
            const fieldMatch = this.field === '전체' || expert.field === this.field;
            const reviewTypeMatch = this.reviewType === '전체 (QA/KG)'
                || expertReviewType === this.reviewType
                || expertReviewType === 'QA·KG';
            const statusMatch = this.statusFilter === '전체'
                || (this.statusFilter === '활성' ? expert.active : !expert.active);
            const availability = this.availability(expert);
            const capacityMatch = this.capacityFilter === '전체'
                || (this.capacityFilter === '높음' && availability >= 70)
                || (this.capacityFilter === '보통' && availability >= 40 && availability < 70)
                || (this.capacityFilter === '낮음' && availability < 40);
            const immediateMatch = !this.immediateOnly || this.isImmediate(expert);
            const queryMatch = !query
                || String(expert.name || '').toLowerCase().indexOf(query) >= 0
                || String(expert.email || '').toLowerCase().indexOf(query) >= 0
                || String(expert.field || '').toLowerCase().indexOf(query) >= 0;
            return fieldMatch && reviewTypeMatch && statusMatch && capacityMatch && immediateMatch && queryMatch;
        });

        return rows.slice().sort((a: any, b: any) => {
            if (this.sortMode === '이름순') return String(a.name || '').localeCompare(String(b.name || ''), 'ko');
            if (this.sortMode === '평점 높은 순') return this.ratingValue(b) - this.ratingValue(a);
            return this.availability(b) - this.availability(a);
        });
    }

    public totalPages() {
        return Math.max(1, Math.ceil(this.filteredExperts().length / this.pageSize));
    }

    public pageNumbers() {
        return Array.from({ length: this.totalPages() }, (_value: unknown, index: number) => index + 1);
    }

    public pagedExperts() {
        const safePage = Math.min(Math.max(1, this.currentPage), this.totalPages());
        if (safePage !== this.currentPage) this.currentPage = safePage;
        const start = (safePage - 1) * this.pageSize;
        return this.filteredExperts().slice(start, start + this.pageSize);
    }

    public resetPage() {
        this.currentPage = 1;
        this.expandedId = null;
    }

    public async goToPage(page: number) {
        this.currentPage = Math.min(Math.max(1, page), this.totalPages());
        this.expandedId = null;
        await this.service.render();
    }

    public progress(expert: any) {
        const assigned = Number(expert.assigned) || 0;
        if (!assigned) return 0;
        return Math.min(100, Math.round((Number(expert.completed) || 0) / assigned * 100));
    }

    public availability(expert: any) {
        if (expert.availability !== undefined && expert.availability !== null) {
            return Math.max(0, Math.min(100, Number(expert.availability) || 0));
        }
        const load = (Number(expert.activeProjects) || 0) * 12 + (Number(expert.due) || 0) * 2;
        return Math.max(10, Math.min(100, 100 - load));
    }

    public capacityLabel(expert: any) {
        const value = this.availability(expert);
        if (value >= 80) return '매우 높음';
        if (value >= 60) return '높음';
        if (value >= 40) return '보통';
        return '낮음';
    }

    public capacityClass(expert: any) {
        const value = this.availability(expert);
        if (value >= 70) return 'is-high';
        if (value >= 40) return 'is-medium';
        return 'is-low';
    }

    public reviewTypeLabel(expert: any) {
        if (expert.reviewType) return expert.reviewType;
        const context = (String(expert.field || '') + ' ' + String(expert.subfield || '')).toLowerCase();
        return context.indexOf('지식') >= 0 || context.indexOf('근거') >= 0 || context.indexOf('kg') >= 0 ? 'QA·KG' : 'QA';
    }

    public skills(expert: any) {
        const values = [expert.field, expert.subfield, this.reviewTypeLabel(expert)]
            .filter((item: any) => Boolean(item));
        return Array.from(new Set(values)).slice(0, 3);
    }

    public expectedAssignments(expert: any) {
        return Math.max(Number(expert.assigned) || 0, (Number(expert.due) || 0) + 15);
    }

    public ratingValue(expert: any) {
        const value = Number(expert.rating);
        return Number.isFinite(value) ? value : 0;
    }

    public ratingLabel(expert: any) {
        const value = this.ratingValue(expert);
        return value > 0 ? value.toFixed(1) : '-';
    }

    public isImmediate(expert: any) {
        return Boolean(expert.active) && this.availability(expert) >= 80 && Number(expert.activeProjects || 0) === 0;
    }

    public nextAvailableLabel(expert: any) {
        if (this.isImmediate(expert)) return '즉시 배정 가능';
        if (expert.nextAvailable) return expert.nextAvailable;
        const day = Math.min(30, 24 + Math.max(0, Number(expert.activeProjects) || 0));
        return '2026-08-' + String(day).padStart(2, '0');
    }

    public assignableCount() {
        return this.experts.filter((expert: any) => expert.active && this.availability(expert) >= 60).length;
    }

    public attentionCount() {
        return this.experts.filter((expert: any) => !expert.active || this.availability(expert) < 60 || Number(expert.due || 0) > 12).length;
    }

    public totalActiveProjects() {
        return this.experts.reduce((total: number, expert: any) => total + Number(expert.activeProjects || 0), 0);
    }

    public immediateCount() {
        return this.experts.filter((expert: any) => this.isImmediate(expert)).length;
    }

    public activeExpertCount(active: boolean) {
        return this.experts.filter((expert: any) => Boolean(expert.active) === active).length;
    }

    public averageRating() {
        const rated = this.experts.map((expert: any) => this.ratingValue(expert)).filter((rating: number) => rating > 0);
        if (!rated.length) return '-';
        return (rated.reduce((sum: number, rating: number) => sum + rating, 0) / rated.length).toFixed(1);
    }

    public fieldOptions() {
        return Array.from(new Set(this.experts.map((expert: any) => String(expert.field || '')).filter(Boolean)));
    }

    public compactFilterOptions(key: string): Array<{ value: string; label: string }> {
        if (key === 'field') return [
            { value: '전체', label: '전문 분야 · 전체' },
            ...this.fieldOptions().map((field: string) => ({ value: field, label: field }))
        ];
        if (key === 'reviewType') return [
            { value: '전체 (QA/KG)', label: '검수 유형 · 전체' },
            { value: 'QA', label: 'QA' },
            { value: 'KG', label: 'KG' },
            { value: 'QA·KG', label: 'QA·KG' }
        ];
        if (key === 'status') return [
            { value: '전체', label: '활성 상태 · 전체' },
            { value: '활성', label: '활성' },
            { value: '비활성', label: '비활성' }
        ];
        return [
            { value: '전체', label: '가용량 · 전체' },
            { value: '높음', label: '높음' },
            { value: '보통', label: '보통' },
            { value: '낮음', label: '낮음' }
        ];
    }

    public compactFilterLabel(key: string) {
        const value = key === 'field' ? this.field
            : key === 'reviewType' ? this.reviewType
                : key === 'status' ? this.statusFilter
                    : this.capacityFilter;
        const option = this.compactFilterOptions(key).find((item: any) => item.value === value);
        return option ? option.label : value;
    }

    public sortOptions() {
        return ['가용량 높은 순', '평점 높은 순', '이름순'];
    }

    public async toggleCompactFilter(key: string) {
        this.openCompactFilter = this.openCompactFilter === key ? '' : key;
        await this.service.render();
    }

    public async selectCompactFilter(key: string, value: string) {
        if (key === 'field') this.field = value;
        else if (key === 'reviewType') this.reviewType = value;
        else if (key === 'status') this.statusFilter = value;
        else this.capacityFilter = value;
        this.openCompactFilter = '';
        this.resetPage();
        await this.service.render();
    }

    public async selectSortMode(value: string) {
        this.sortMode = value;
        this.openCompactFilter = '';
        this.resetPage();
        await this.service.render();
    }

    public async closeCompactFilter(event: any) {
        const relatedTarget = event && event.relatedTarget;
        const currentTarget = event && event.currentTarget;
        if (relatedTarget && currentTarget && currentTarget.contains(relatedTarget)) return;
        this.openCompactFilter = '';
        await this.service.render();
    }

    @HostListener('document:click', ['$event'])
    public async closeCompactFilterFromOutside(event: MouseEvent) {
        if (!this.openCompactFilter) return;
        const target = event.target as HTMLElement | null;
        if (target && target.closest('.expert-compact-filter, .expert-capacity-sort')) return;
        this.openCompactFilter = '';
        await this.service.render();
    }

    public hasFilters() {
        return Boolean(this.keyword)
            || this.field !== '전체'
            || this.reviewType !== '전체 (QA/KG)'
            || this.statusFilter !== '전체'
            || this.capacityFilter !== '전체'
            || this.immediateOnly;
    }

    public async setCapacityFilter(value: string) {
        this.capacityFilter = this.capacityFilter === value ? '전체' : value;
        this.resetPage();
        await this.service.render();
    }

    public async setStatusFilter(value: string) {
        this.statusFilter = value;
        this.resetPage();
        await this.service.render();
    }

    public async resetFilters() {
        this.keyword = '';
        this.field = '전체';
        this.reviewType = '전체 (QA/KG)';
        this.statusFilter = '전체';
        this.capacityFilter = '전체';
        this.openCompactFilter = '';
        this.immediateOnly = false;
        this.sortMode = '가용량 높은 순';
        this.resetPage();
        await this.service.render();
    }

    public async toggleDetails(expert: any) {
        this.expandedId = this.expandedId === expert.id ? null : expert.id;
        await this.service.render();
    }

    public async toggleActive(expert: any) {
        expert.active = !expert.active;
        this.persistExperts();
        await this.service.render();
    }

    public async assignRecommended(expert: any) {
        expert.activeProjects = Number(expert.activeProjects || 0) + 1;
        expert.assigned = Number(expert.assigned || 0) + 6;
        expert.due = Number(expert.due || 0) + 6;
        expert.availability = Math.max(0, this.availability(expert) - 18);
        expert.nextAvailable = '2026-08-30';
        this.persistExperts();
        await this.service.render();
        await this.service.modal.success(expert.name + ' 전문가에게 추천 작업을 배정했습니다.');
    }

    public async chooseAnotherTask(expert: any) {
        await this.service.modal.info(expert.name + ' 전문가에게 배정할 다른 작업을 선택할 수 있도록 작업 목록을 준비 중입니다.');
    }

    public async openInvite() {
        await this.loadRegisteredUsers();
        this.invite = { name: '', email: '', field: '동북아 역사', reviewType: 'QA·KG' };
        this.userQuery = '';
        this.selectedUserId = '';
        this.registeredUsers.forEach((user: any) => user.selected = false);
        this.showInviteModal = true;
        await this.service.render();
    }

    public async closeInvite() {
        this.showInviteModal = false;
        await this.service.render();
    }

    public filteredRegisteredUsers() {
        const query = this.userQuery.trim().toLowerCase();
        return this.registeredUsers.filter((user: any) => !query
            || String(user.name || '').toLowerCase().indexOf(query) >= 0
            || String(user.email || '').toLowerCase().indexOf(query) >= 0);
    }

    public async selectRegisteredUser(user: any) {
        if (user.role !== '검수자') return;
        this.registeredUsers.forEach((item: any) => item.selected = item.id === user.id);
        this.selectedUserId = user.id;
        this.invite.name = user.name;
        this.invite.email = user.email;
        await this.service.render();
    }

    public async inviteMock() {
        if (!this.selectedUserId) {
            await this.service.modal.warning('가입 사용자 목록에서 검수자 계정을 선택해주세요.', false, '확인');
            return;
        }

        if (this.experts.some((expert: any) => String(expert.email || '').toLowerCase() === String(this.invite.email || '').toLowerCase())) {
            await this.service.modal.warning('이미 전문가로 등록된 사용자입니다.', false, '확인');
            return;
        }

        const expert = {
            id: this.nextExpertId(),
            name: this.invite.name.trim(),
            email: this.invite.email.trim(),
            field: this.invite.field,
            subfield: '신규 등록',
            reviewType: this.invite.reviewType,
            assigned: 0,
            completed: 0,
            activeProjects: 0,
            rating: '-',
            active: true,
            due: 0,
            availability: 100,
            nextAvailable: '즉시 배정 가능'
        };
        this.experts.unshift(expert);
        this.persistExperts();
        this.resetPage();
        this.showInviteModal = false;
        await this.service.render();
        await this.service.modal.success('전문가가 추가되었습니다.');
    }
}

export default PageExpertsComponent;